<template>
    <div>
        <!-- Title when Opened from Work Order View Page-->
        <template v-if="poInvoiceFromWO != undefined">
            <div class="form-title">
                <span id="BillHeader" v-if="poDataFromWO != undefined && poDataFromWO.billId > 0">Update Vendor Invoice</span>
                <span id="BillHeader" v-else>Add Vendor Invoice</span>
            </div>
        </template>
        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="BillForm">
            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                <div class="col form-group" v-if="$route.params.id != undefined && (poInvoiceFromWO == undefined || (poInvoiceFromWO != undefined && poDataFromWO != undefined && poDataFromWO.billId > 0 ))">
                    <label class="control-label" for="voucher">Voucher Number: </label>
                    <span class="label">{{voucher}}</span>
                </div>
            </div>
            <div class="form-row row-cols-md-4 row-cols-1">
                <div class=" col form-group" v-if="poInvoiceFromWO == undefined">
                    <label class="control-label require" for="vendor_invoice_type">Type:</label>
                    <v-select id="vendor_invoice_type" v-model="vendor_invoice_type" name="vendor_invoice_type" @change="changeType" placeholder="Select Type." label="text"
                    class="close-remove" :options="vendorInvoiceTypesArr" @input="onTypeSelect($event)" :disabled="disableInvType">
                    </v-select>
                    <div class="field-error">{{ vendor_invoice_type_error_msg }}</div>
                </div>
                <div class="col col-md-6 form-group">
                    <label class="control-label require" for="vendor_id">Vendor:</label>
                    <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor Code or Name" class="custom-ci-auto-search" @input="onVendorChange()" :disabled="disableVendorPOField">
                        <template slot="no-options">
                            Search Vendor Code or Name...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{ vendor_error_msg }}</div>
                </div>
                <div class="col form-group" v-if="poInvoiceFromWO == undefined">
                    <label class="control-label" for="period">Assignee:</label>
                    <v-select v-model="assignee" name="assignee" label="text" :filterable="false" :options="assigneeArr" @search="onSearchAssignee" placeholder="Select Assignee Code or Name" class="custom-ci-auto-search">
                        <template slot="no-options">
                            Search Assignee Code or Name...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{assignee_error}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="period">#Invoice:</label>
                    <input type="text" class="form-control" v-model="bill_number" id="bill_number" placeholder="Enter Invoice Number" name="bill_number">
                    <div class="field-error">{{bill_error}}</div>
                </div>
                <div class="col form-group" v-if="poInvoiceFromWO == undefined">
                    <label class="control-label" for="reference">Reference Number:</label>
                    <input type="text" class="form-control" v-model="reference" id="reference_number" placeholder="Enter Reference Number" name="reference_number">
                    <div class="field-error"></div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="bill_date">Invoice Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="bill_date" name="bill_date" v-model="bill_date" :config="optionsDate"></date-picker>
                        <label for="bill_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ bill_date_error_msg }}</div>
                </div>
                <div class=" col form-group">
                    <label class="control-label" for="due_date">Due Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="due_date" name="due_date" v-model="due_date" :config="optionsDueDate"></date-picker>
                        <label for="due_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{ due_date_error_msg }}</div>
                </div>
                <div class="col form-group" v-if="vendor_inv_type != 'default' || (vendor_inv_type == 'default' && is_misc_po == 1)">
                    <label class="control-label" for="po">PO:</label>
                    <v-select v-model="po" name="po"
                            label="text" :filterable="false" :options="purchaseOrderArr"
                            @search="onSearchPurchaseOrder"
                            placeholder="Select PO" class="custom-ci-auto-search" @input="onPOSelect($event)" :disabled="disablePOField">
                        <template slot="no-options">
                            Search PO...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{ po_error_msg }}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label" for="state">Location:</label>
                    <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text" :options="locationArr" :disabled="disableVendorPOField">
                    </v-select>
                    <div class="field-error">{{location_error_msg}}</div>
                </div>
                <div class=" col form-group">
                    <label class="control-label" for="postPeriod">Period:</label>
                    <input type="text" class="form-control" v-cleave="{delimiter: '/',blocks: [2, 4]}" v-model="postPeriod" :id="'postPeriod' + index" placeholder="MM/YYYY" name="postPeriod">
                    <!-- <input-mask id="postPeriod" :alwaysShowMask="false" name="postPeriod" v-model="postPeriod" mask="99/9999" class="form-control" placeholder="MM/YYYY"></input-mask> -->
                    <div class="field-error">{{post_period_error_msg}}</div>
                </div>
                <div class="col form-group">
                    <label class="control-label require" for="payment_type">Payment Type:</label>
                    <v-select v-model="payment_type" name="payment_type" placeholder="Select Payment Type."
                            label="text"
                            :options="paymentArr">
                    </v-select>
                    <div class="field-error">{{ paymentTypeError }}</div>
                </div>
                <div class="col form-group" v-if="poInvoiceFromWO == undefined">
                    <label class="control-label" for="period">Notes:</label>
                    <textarea class="form-control" v-model="notes" id="attention" placeholder="Enter Notes" name="Notes">
                    </textarea>
                    <div class="field-error">{{notes_error_msg}}</div>
                </div>
                <div class="col form-group" v-if="vendor_inv_type == 'default'">
                    <label class="control-label" for="voucher">Paste Excel Rows: </label>
                    <textarea class='form-control' v-model="excelRows" ref="excelRows" id="excelRows" @input="addExcelRows()"></textarea>
                </div>
            </div>
            <div class="form-row row-cols-md-2 row-cols-1 ach-payment-section">
                    <div class="col form-group verification-section-main">
                        <label :class="'control-label '+fileRequired">File:</label>
                        <div class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin">
                            <div id="app2">
                                <vue-dropzone id="vendorInvDocs"
                                    :options="dropzoneOptions"
                                    :destroyDropzone=false
                                    ref="vendorInvDropzone"
                                    :headers="dropzoneOptions.headers"
                                    @vdropzone-complete="afterComplete"
                                    @vdropzone-success="storeDocument"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    >
                                </vue-dropzone>
                                <div class="field-error">{{fileerror_msg}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col form-group"  v-if="dropZonePreviewFiles.length > 0">
                        <div class="policy-attachment attachment-list-box">
                            <label class="control-label" for="attachments"></label>
                            <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                    <i v-if="uFile.ext == 'pdf'" class="fp-pdf-icon"></i>
                                    <i v-if="uFile.ext == 'doc' || uFile.ext == 'docs'" class="fp-text-document"></i>
                                    <i v-if="uFile.ext == 'jpg' ||  uFile.ext == 'png' ||  uFile.ext == 'jpeg' " class="fp-image"></i>
                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.ext)" v-bind:key="'fileName'+fKey" >
                                        {{ uFile.name }}
                                    </a>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="deleteBillFile(fKey,uFile.path);">
                                        <i class="fp-close"></i>
                                    </button>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            <hr class="light-hr"/>
            <div class = "form-row">

                <div class="col-md-5 ">
                    <template v-if="vendorGLAccounts && vendorGLAccounts.length > 0 && vendor_invoice_type.value == 'default'">
                            <label class="font-bold"> PREVIOUS GL ACCOUNT </label>
                            <template v-if="vendorGLAccounts.length < 4">
                                  <table aria-describedby="table" class="table table-sm table-bordered">
                                      <tr v-for="(m, index) in vendorGLAccounts" :key="index">
                                        <td>
                                          <span>{{m.text}}</span>
                                        </td>
                                      </tr>
                                </table>
                            </template>
                            <template v-if="vendorGLAccounts.length > 4">
                              <div style="height:140px;overflow:auto;">
                                  <table aria-describedby="table" class="table table-sm table-bordered">
                                      <tr v-for="(m, index) in vendorGLAccounts" :key="index">
                                        <td>
                                          <span>{{m.text}}</span>
                                        </td>
                                      </tr>
                                </table>
                            </div>
                          </template>
                  </template>
                </div>
                  <hr class="light-hr" v-if="vendor_inv_type != 'default'"/>
                  <div class="col-md-7 order-summary " v-if="showTotalSummary || poInvoiceFromWO"> <!--Description section-->
                      <!-- <div class="row"> -->
                          <div class="col-md-9 offset-md-3">
                              <div class="">
                                  <label class="font-bold"> SUMMARY </label>
                                  <table aria-describedby="table" class="table table-sm table-bordered">
                                      <tr class="">
                                          <td> Total: </td>
                                          <td class="text-right">

                                              <div class="input-group w-60 pull-right">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text" id="basic-addon4">$</span>
                                                  </div>
                                                  <template v-if="vendor_inv_type == 'item' || vendor_inv_type == 'sublet_invoice' || vendor_inv_type == 'default'">
                                                    <input type="text" class="form-control text-right" v-model="receipt_amount" id="receipt_amount"
                                                    placeholder="Enter Receipt Amount" name="receipt_amount"
                                                    @blur="receipt_amount = leaveFocus($event)"
                                                    @focus="receipt_amount = enterVal($event)"
                                                    @keypress="isNumberOnly($event)">
                                                  </template>
                                                  <template v-else>
                                                      <input type="text" class="form-control text-right" v-model="receipt_amount" id="receipt_amount"
                                                        placeholder="Enter Receipt Amount" name="receipt_amount"
                                                        @blur="receipt_amount = leaveFocus($event)"
                                                        @focus="receipt_amount = enterVal($event)"
                                                        @keypress="isNumberCheck($event)">
                                                  </template>
                                              </div>

                                          </td>
                                      </tr>

<!--                                      <tr>-->
<!--                                          <td> Tax Amount: </td>-->
<!--                                          <td>-->
<!--                                              <div class="input-group w-60 pull-right">-->
<!--                                                  <div class="input-group-prepend">-->
<!--                                                      <span class="input-group-text" id="basic-addon4">$</span>-->
<!--                                                  </div>-->
<!--                                                  <input type="text" class="form-control text-right" v-model="total_tax"-->
<!--                                                  id="total_tax" placeholder="Enter Tax Amount" name="total_tax"-->
<!--                                                  @blur="total_tax = leaveFocus($event)"-->
<!--                                                  @focus="total_tax = enterVal($event)"-->
<!--                                                  @keypress="isNumberOnly($event)">-->
<!--                                              </div>-->
<!--                                          </td>-->
<!--                                      </tr>-->
                                      <tr class="table-secondary">
                                          <td> Subtotal: </td>
                                          <td class="text-right"> {{currencyFormat(sub_total)}} </td>

                                      </tr>
                                      <!-- <tr class="table-secondary">
                                          <td> Discount: </td>
                                          <td class="text-right"> ${{totalDiscount.toFixed(2)}} </td>
                                      </tr> -->
                                      <tr>
                                          <td class=""> Difference: </td>
                                          <td class="text-right"> {{currencyFormat(difference)}} </td>
                                      </tr>
                                      <!--tr>
                                          <td> Total: </td>
                                          <td class="order-total text-right"> ${{total.toFixed(2)}} </td>
                                      </tr-->
                                  </table>
                              </div>
                          </div>
                      <!-- </div> -->
                  </div> <!--Description section-->
            </div>
            <div v-if="part_search_error_msg != null" class="field-error">{{part_search_error_msg}}</div>
            <div class="purchase-order-create-main table-responsive-sm">
                <template v-if="poInvoiceFromWO != undefined || ( vendor_inv_type == 'sublet_invoice')">

                    <table aria-describedby="table" id="vendor-invoice-line-items-tbl" class="table table-sm table-bordered font-1">
                        <thead>
                            <tr class="table-primary">
                                <th scope="col" style="width:250px" class="require">Description</th>
                                <th scope="col" style="width:100px" class="require">Unit No.</th>
                                <th scope="col" style="width:100px" class="require">Labor Amount</th>
                                <th scope="col" style="width:100px" class="require">Part Amount</th>
                                <th scope="col" style="width:50px"> Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in rows" :key="index">
                                <td>
                                    <textarea cols="45" v-model="row.description" name="description" placeholder="Description" class="vgt-input">
                                    </textarea>
                                    <div class="field-error">{{row.desc_error_msg}}</div>
                                </td>
                                <td>
                                    <v-select v-model="row.vehicle_id" id="vehicle_id" name="vehicle_id" label="unit_no" :filterable="false" :options="vehicleArr" @search="onSearchAsset"
                                        placeholder="Select Unit No." class="custom-ci-auto-search" :disabled="true">
                                        <template slot="no-options">
                                            Search Unit No...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.unit_no }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.unit_no }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{row.vehicle_error_msg}}</div>
                                </td>
                                <td>
                                    <input type="text" placeholder="Labor Amount" v-model="row.labor" v-on:keyup="calculateSubletInvoice($event,index)" @keypress="isNumberOnly($event)" name="row.labor" @blur="leaveFocusUnitPrice($event,index,'labor')" @focus="enterUnitPrice($event,index,'labor')" class="form-control text-right">
                                    <div class="field-error">{{row.labor_error_msg}}</div>
                                </td>
                                <td>
                                    <input type="text" placeholder="Part Amount" v-model="row.materials" v-on:keyup="calculateSubletInvoice($event,index)" @keypress="isNumberOnly($event)" name="row.materials" @blur="leaveFocusUnitPrice($event,index,'material')" @focus="enterUnitPrice($event,index,'material')" class="form-control text-right">
                                    <div class="field-error">{{row.materials_error_msg}}</div>
                                </td>
                                <td class="text-center valign-middle">
                                    <template v-if="rows.length > 1">
                                        <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeElement(index);"> ×
                                            </a></span>
                                    </template>
                                    <template v-else>
                                        <span class="close-row"> _ </span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <hr class="light-hr"/>
                    <div class="purchase-order-create-main table-responsive-sm" v-if="vendor_inv_type != 'default'">
                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                            <thead>
                                <tr class="table-primary">
                                    <th scope="col" class="require" style="width:400px">Charge Type</th>
                                    <th scope="col" class="require">Quantity</th>
                                    <th scope="col" class="require">Price</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col"> Action </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                    <td>
                                        <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                                    label="text"
                                                    :options="chargesArr" @input="onChargeSelect($event,chindex)"> <!-- :disabled="(order_id != '') ? true : false" -->
                                        </v-select>
                                        <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Quantity" v-model="chrow.quantity" name="quantity" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberOnly($event)" id="quantity" class="form-control text-right">
                                        <div class="field-error">{{chrow.quantity_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Price" v-model="chrow.unit_price" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberOnly($event)" name="row.unit_price" @blur="leaveFocusUnitPrice($event,chindex,'charge')" @focus="enterUnitPrice($event,chindex,'charge')" class="form-control text-right">
                                        <div class="field-error">{{chrow.unit_price_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" disabled placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right">
                                    </td>
                                    <td class="text-center valign-middle">
                                        <template v-if="chrows.length != 0" >
                                            <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                                </a></span>
                                        </template>
                                        <template v-else>
                                            <span class="close-row"> _ </span>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-groups mt-2" v-if="vendor_inv_type != 'default'">
                        <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                            <i class="fp-add"></i> Add Charge
                        </button>
                    </div>
                </template>
                <template v-else>
                    <table aria-describedby="table" id="vendor-invoice-line-items-tbl" class="table table-sm table-bordered font-1">
                        <thead>
                            <tr class="table-primary">
                                <template v-if="vendor_inv_type == 'item'">
                                    <th scope="col" style="width:200px" class="require">Part</th>
                                </template>
                                <template v-else-if="vendor_inv_type == 'sublet_po'">
                                    <th scope="col" style="width:250px" class="require">Description</th>
                                    <th scope="col" style="width:200px" class="require">Part</th>
                                </template>
                                <template v-else-if="vendor_inv_type == 'sublet_invoice' || vendor_inv_type == 'equipment' && order_id == ''">
                                    <th scope="col" style="width:250px" class="require">Description</th>
                                </template>
                                <template v-else-if="vendor_inv_type == 'equipment' && order_id != ''">
                                    <th scope="col" style="width:250px" class="require">Unit#</th>
                                    <th scope="col" style="width:250px">VIN#</th>
                                </template>
                                <template v-else>
                                    <!-- <th scope="col" style="width:200px" class="require">Part</th> -->
                                    <th scope="col" class="require" style="width:200px">GL Account</th>
                                    <th cope="col" style="width:100px" class="require" v-if="vendor_inv_type == 'default' && is_misc_po == 1">Qty/Hrs</th>
                                    <th cope="col" style="width:100px" class="require" v-if="vendor_inv_type == 'default' && is_misc_po == 1">Unit Price</th>
                                    <th scope="col" style="width:100px" class="require">Amount</th>
                                    <th scope="col" style="width:250px">Description</th>
                                </template>
                                <!-- <th scope="col" class="require" style="width:200px">GL Account</th> -->
                                <template v-if="vendor_inv_type == 'item' || vendor_inv_type == 'equipment'">
                                    <th scope="col" style="width:100px" class="require">Qty/Hrs</th>
                                    <th scope="col" style="width:100px" class="require">Unit Price</th>
                                    <th scope="col" style="width:100px" class="require">Amount</th>
                                </template>
                                <!-- <th scope="col" v-show="showMoreLessFlag" style="width:100px">Tax</th> -->
                                <!-- <th scope="col" style="width:100px" class="require">Amount</th> -->
                                <template v-if="vendor_inv_type == 'item' || vendor_inv_type == 'default'">
                                    <th scope="col" style="width:100px">Unit No.</th>
                                </template>
                                <th scope="col" style="width:50px"> Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in rows" :key="index">

                                <template v-if="vendor_inv_type == 'item'">
                                    <td>
                                        <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search Part...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{row.part_error_msg}}</div>
                                    </td>
                                </template>
                                <template v-else-if="vendor_inv_type == 'sublet_po'">
                                    <td>
                                        <textarea v-model="row.description" name="description" placeholder="Description" class="form-control" rows="1" cols="45">
                                        </textarea>
                                        <div class="field-error">{{row.desc_error_msg}}</div>
                                    </td>
                                    <td>
                                        <v-select v-model="row.part" name="part" id="part" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Select Part" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search Part...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{row.part_error_msg}}</div>
                                    </td>
                                </template>
                                <template v-else-if="vendor_inv_type == 'sublet_invoice' || vendor_inv_type == 'equipment' && order_id == ''">
                                    <td>
                                        <textarea v-model="row.description" name="description" placeholder="Description" class="form-control" rows="1" cols="45">
                                        </textarea>
                                        <div class="field-error">{{row.desc_error_msg}}</div>
                                    </td>
                                </template>
                                 <template v-else-if="vendor_inv_type == 'sublet_invoice' || vendor_inv_type == 'equipment'&& order_id != ''">
                                    <td>
                                        <!--textarea v-model="row.description" name="unit" placeholder="Unit#" class="vgt-input">
                                        </textarea-->
                                        <input type="text" class="form-control" v-model="row.unit" id="unit"
                                        placeholder="Unit#" name="unit" :disabled='true'>
                                        <div class="field-error">{{row.unit_error_msg}}</div>
                                    </td>
                                    <td>
                                        <!--textarea v-model="row.description" name="vin" placeholder="VIN#" class="vgt-input">
                                        </textarea-->
                                        <input type="text" class="form-control" v-model="row.description" id="description"
                                        placeholder="VIN#" name="description">
                                        <div class="field-error">{{row.desc_error_msg}}</div>
                                    </td>
                                </template>
                                <template v-else>

                                    <td>
                                        <v-select v-model="row.gl_account_id" name="gl_account_id" id="gl_account_id" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select GL Account" class="custom-ci-auto-search contract-data">
                                            <template slot="no-options">
                                                Search GL Account...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error gl-account-error">{{row.gl_account_error_msg}}</div>
                                    </td>
                                    <td v-if="vendor_inv_type == 'default' && is_misc_po == 1">
                                        <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity" @keypress="isNumberOnly($event)" v-on:keyup="calculateAmount($event,index)" id="quantity" class="form-control text-right">
                                    </td>
                                    <td v-if="vendor_inv_type == 'default' && is_misc_po == 1">
                                        <input type="text" placeholder="Price" v-model="row.unit_price" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" @blur="leaveFocusUnitPrice($event,index,'item-price')" @focus="enterUnitPrice($event,index,'item-price')" name="row.unit_price" class="form-control text-right">
                                        <div class="field-error">{{row.unit_price_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Amount"  v-model="row.amount" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberOnly($event)" id="amount" name="amount" @blur="leaveFocusUnitPrice($event,index,'amount')" @focus="enterUnitPrice($event,index,'amount')" class="form-control text-right">
                                        <div class="field-error">{{row.amount_error_msg}}</div>
                                    </td>
                                    <td>
                                        <textarea v-model="row.description" name="description" placeholder="Description" class="form-control" rows="1">
                                        </textarea>
                                        <div class="field-error">{{row.desc_error_msg}}</div>
                                    </td>
                                </template>

                                <td v-if="vendor_inv_type == 'item' || vendor_inv_type == 'equipment'">
                                    <template v-if="vendor_inv_type == 'item'">
                                        <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity" @keypress="isNumberOnly($event)" v-on:keyup="calculateAmount($event,index)" id="quantity" class="form-control text-right">
                                    </template>
                                    <template v-else>
                                        <input type="text" placeholder="Quantity" v-model="row.quantity" name="quantity" @keypress="isNumberCheck($event)" v-on:keyup="calculateAmount($event,index)" id="quantity"
                                        class="form-control text-right" :disabled='isQtryDisable'>
                                    </template>
                                    <div class="field-error">{{row.quantity_error_msg}}</div>
                                </td>
                                <td v-if="vendor_inv_type == 'item' || vendor_inv_type == 'equipment'">
                                    <input type="text" placeholder="Price" v-model="row.unit_price" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" @blur="leaveFocusUnitPrice($event,index,'item-price')" @focus="enterUnitPrice($event,index,'item-price')" name="row.unit_price" class="form-control text-right">
                                    <div class="field-error">{{row.unit_price_error_msg}}</div>
                                </td>
                                <!-- <td v-show="showMoreLessFlag">
                                    <v-select v-model="row.tax_id" name="tax_id" placeholder="Select Tax." label="text" :options="taxesArr" @input="onTaxSelect($event,index)" :disabled="row.enableTaxSelect">
                                    </v-select>
                                </td> -->
                                <td v-if="vendor_inv_type == 'item' || vendor_inv_type == 'equipment'">
                                    <input type="text" placeholder="Amount"  v-model="row.amount" v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event)" id="amount" name="amount" class="form-control text-right" @blur="leaveFocusUnitPrice($event,index,'amount')" @focus="enterUnitPrice($event,index,'amount')" :disabled="true">
                                    <div class="field-error">{{row.amount_error_msg}}</div>
                                </td>
                                <td v-if="vendor_inv_type == 'item' || vendor_inv_type == 'default'">
                                    <v-select v-model="row.vehicle_id" id="vehicle_id" name="vehicle_id" label="text" :filterable="false" :options="vehicleArr" @search="onSearchAsset" placeholder="Select Unit No." class="custom-ci-auto-search contract-data">
                                        <template slot="no-options">
                                            Search Unit No...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                </td>
                                <td class="text-center valign-middle">
                                    <template v-if="rows.length > 1">
                                        <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeElement(index);"> ×
                                            </a></span>
                                    </template>
                                    <template v-else>
                                        <span class="close-row"> _ </span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="btn-groups" v-if="poInvoiceFromWO == undefined && vendor_inv_type != 'sublet_invoice' && order_id == ''">
                        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                            <i class="fp-add"></i>Add Line Item
                        </button>
                    </div>
                    <hr class="light-hr"/>
                    <div class="purchase-order-create-main table-responsive-sm" v-if="vendor_inv_type != 'default' && isChargeAvail == true">
                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                            <thead>
                                <tr class="table-primary">
                                    <th scope="col" class="require" style="width:280px">Charge Type</th>
                                    <template v-if="vendor_inv_type == 'equipment'">
                                        <th scope="col" style="width:120px">Unit#</th>
                                    </template>
                                    <th scope="col" class="require">Quantity</th>
                                    <th scope="col" class="require">Price</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col"> Action </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(chrow, chindex) in chrows" :key="chindex">
                                    <td>
                                        <v-select v-model="chrow.charge_id" name="charge_id" placeholder="Select Charge."
                                                    label="text"
                                                    :options="chargesArr" @input="onChargeSelect($event,chindex)"> <!-- :disabled="(order_id != '') ? true : false" -->
                                        </v-select>
                                        <div class="field-error">{{chrow.charge_type_error_msg}}</div>
                                    </td>
                                    <template v-if="vendor_inv_type == 'equipment'">
                                        <td>
                                            <v-select v-model="chrow.vehicle_id" name="vehicle_unit_id" placeholder="Select Unit No."
                                                    label="text"
                                                    :options="chargesUnitArr">
                                            </v-select>
                                        </td>
                                    </template>
                                    <td>
                                        <input type="text" placeholder="Quantity" v-model="chrow.quantity" name="quantity" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberOnly($event)" id="quantity" class="form-control text-right">
                                        <div class="field-error">{{chrow.quantity_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" placeholder="Price" v-model="chrow.unit_price" v-on:keyup="calculateChargeAmount($event,chindex)" @keypress="isNumberOnly($event)" name="row.unit_price" @blur="leaveFocusUnitPrice($event,chindex,'charge')" @focus="enterUnitPrice($event,chindex,'charge')" class="form-control text-right">
                                        <div class="field-error">{{chrow.unit_price_error_msg}}</div>
                                    </td>
                                    <td>
                                        <input type="text" disabled placeholder="Amount" v-model="chrow.amount" id="amount" name="amount" class="form-control text-right">
                                    </td>
                                    <td class="text-center valign-middle">
                                        <template v-if="chrows.length != 0" >
                                            <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeChargeElement(chindex);"> ×
                                                </a></span>
                                        </template>
                                        <template v-else>
                                            <span class="close-row"> _ </span>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="btn-groups" v-if="vendor_inv_type != 'default'">
                        <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary">
                            <i class="fp-add"></i> Add Charge
                        </button>
                    </div>
                </template>
            </div>

            <div class="field-error" style="font-size:18px;">{{common_error_msg}}</div>

            <div class="form-group">
                <div class="alert alert-warning hide col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                </div>
            </div>
            <div class="btn-groups">
                <button type="submit" v-if="$route.params.id > 0 && (poInvoiceFromWO == undefined || (poInvoiceFromWO != undefined && poDataFromWO != undefined && poDataFromWO.billId > 0 ))" id="CreateBillBtn" class="btn btn-primary" v-on:click.prevent="CreateBill">
                    <i class="fp-reload"> </i> Update
                </button>
                <button type="submit" v-else id="CreateBillBtn" class="btn btn-primary" v-on:click.prevent="CreateBill">
                    <i class="fp-save"> </i> Save
                </button>
                <button type="submit" v-if="$route.params.id == undefined && poInvoiceFromWO == undefined && redirectFrom == ''" id="createAndContinueBillBtn" class="btn btn-tertiary" v-on:click.prevent="CreateBill(flag='Save and Continue')">
                    <i class="fp-save-continue"> </i> Save and Continue
                </button>
                <button type="submit" id="cancelBillBtn" class="btn btn-tertiary" v-on:click.prevent="BackBillList">
                    <i class="fp-close"> </i> Cancel
                </button>
            </div>
            <div class="modal fade error-message-modal" id="error-message-modal" ref="errorMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="errorMessageModal" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Message</h5>
                            <button type="button" class="close" id="btnModalClose" v-on:click.prevent="hideMessageModal()">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p class="field-error">Following fields does not match with uploaded invoice:.</p>
                            <template v-if="matchingValuesError.length">
                                <template v-for="(errorField,key) in matchingValuesError">
                                    <a :key="'i' + key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="'j' + key"> {{errorField}}</span>
                                </template>
                            </template>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" id="btnModalok" v-on:click.prevent="submitBill()"> Ok </button>
                            <button class="btn btn-tertiary" id="btnModalCancel" v-on:click.prevent="hideMessageModal()"> Close </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import moment from 'moment';
export default {
    name: "VendorInvoiceForm",
    components: {
        vueDropzone: vue2Dropzone,
    },
    mixins: [commonMixins, contractMixins],
    props: {
        poInvoiceFromWO: {
            type: String,
            required: false,
            default:undefined
        },
        poDataFromWO: {
            type: Object,
            required: false,
            default:undefined
        },
    },
    data: () => ({
        excelRows:"",
        isQtryDisable: false,
        redirectFrom: "",
        order_id: "",
        isEdit: false,
        // permissions: [],
        // cantAccessPage: "",
        bill_number: "",
        receipt_amount: 0,
        bill_error:'',
        vendor_id: null,
        vendorArr: [],
        status: "open",
        open_status: "open",
        closed_status: "closed",
        reserved__status: "reserved",
        openCheckBox: "1",
        closedCheckBox: "1",
        reservedCheckBox: "1",
        loading: false,
        showCharges: false,
        type: "",
        reference:'',
        status_error_msg: "",
        type_error_msg: "",
        amount_error_msg: "",
        tax_percentage_error_msg: "",
        total_charge_error_msg: "",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        rows: [],
        sub_total: 0,
        total: 0,
        difference: 0,
        notes: "",
        userArr: [],
        customer_id: null,
        customer_error_msg: "",
        bill_date: "",
        due_date: "",
        bill_date_error_msg: "",
        due_date_error_msg: "",
        componentArr: [],
        vendor_error_msg: "",
        amount:'',
        tax:0,
        total_tax:0,
        wo_amount_error_msg:'',
        notes_error_msg:'',
        filesArr:[],
        existFilesArr:[],
        bill_id:'',
        purchaseOrderArr:[],
        po:'',
        location_id:"",
        locationArr:[],
        location_error_msg:"",
        taxesArr:[],
        disableStatusField:false,
        po_error_msg:"",
        showTotalSummary:true,
        voucher:'',
        fileerror_msg:'',
        accountsArr:[],
        isPORequired:false,
        poRequiredClass:'',
        isUpdate:false,
        pdfArr:[],
        matchingValuesError:[],
        valuesFound:false,
        assignee:'',
        assignee_error:'',
        disrows:[],
        totalDiscount:0,
        pre_subtotal : 0,
        showMoreLessLabel:"Show More",
        showMoreLessFlag:false,
        pageDescription:"Vendor Invoice Create | " +process.env.COPYRIGHT_NAME,
        watchCall:false,
        accountCanChanged:false,
        chrows:[],
        chargesArr:[],
        vendor_inv_type:"default",
        vendor_invoice_type:{text:'Default' , value:'default'},
        vendor_invoice_type_error_msg:"",
        currentPOAmount:0,
        disableInvType:false,
        disableVendorPOField:false,
        admin_charge:0,
        assigneeArr:[],
        vendorGLAccounts:[],
        isChargeAvail: false,
        vehicleArr:[],
        woType:"",
        vehicleId:"",
        woItemId:"",
        receipt_id: "",
        defaultChargesArr:[],
        postPeriod:"",
        post_period_error_msg:"",
        part_search_error_msg:"",
        is_misc_po:0,
        dropzoneOptions: {
            url: process.env.ROOT_API +"/store-vendor-invoice-docs",
            method: 'POST',
            maxFilesize: 10.00, //MB
            maxFiles: 1,
            thumbnailWidth: 150, // px
            thumbnailHeight: 150,
            addRemoveLinks: true,
            acceptedFiles: ".jpg, .jpeg, .png, .pdf , .doc ,.docx",
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer "+localStorage.getItem("tkn"),
                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                "Cache-Control": "no-cache"
            },
            dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
            destroyDropzone:false,
            dictDefaultMessage: "Drop files here to upload. Max allowed file size is 10MB.",
        },
        disablePOField:false,
        dropZonePreviewFiles:[],
        docArr:[],
        validateDocs:[],
        chargesUnitArr:[],
        default_status:"verified",
        common_error_msg:"",
        fileRequired:'require',
        paymentTypeError:"",
        payment_type_id:'',
        payment_type:null,
        paymentArr: [
        {
            value: "ACH",
            text: "ACH"
        },
        {
            value: "CH",
            text: "CHECK"
        },
        {
            value: "CO",
            text: "COMCHECK"
        },
        {
            value: "CC",
            text: "CREDIT CARD"
        },
    ],
    updateVendor:false,
    }),
    watch: {

        admin_charge: function () {

            var self = this;
            var currentTotal = 0;
            if (self.admin_charge > 0) {
                // currentTotal = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax) + self.removeFormat(self.admin_charge);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                var admCharge = parseFloat(self.removeFormat(self.admin_charge).toFixed(2));
                // currentTotal = subTtl + taxTtl + admCharge;
                currentTotal = subTtl + admCharge;
            }else{
                // currentTotal = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                // currentTotal = subTtl + taxTtl;
                currentTotal = subTtl;
            }
          // console.log("currentTotal    ",currentTotal);return;
            self.total = currentTotal;
            //if admin fee added then update Total Input
            if (self.admin_charge > 0) {
                self.receipt_amount = currentTotal;
            }
            if (self.receipt_amount == "" || self.receipt_amount == "-") {
                self.difference = 0;
            }else{
                // self.difference = self.removeFormat(self.receipt_amount) - self.removeFormat(self.total);
                var recptAmt = parseFloat(self.removeFormat(self.receipt_amount).toFixed(2));
                var diffVal = recptAmt - currentTotal;
                self.difference = diffVal;
            }
            console.log("total == 1");
            // self.difference = self.removeFormat(self.receipt_amount) - self.total;
            console.log("difference = ",self.difference);
        },
        sub_total: function () {
            var self = this;
            var totalAmt = 0;

            if (self.admin_charge > 0) {
                // totalAmt = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax) + self.removeFormat(self.admin_charge);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                var admCharge = parseFloat(self.removeFormat(self.admin_charge).toFixed(2));
                // totalAmt = subTtl + taxTtl + admCharge;
                totalAmt = subTtl + admCharge;
            }else{
                // totalAmt = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                // totalAmt = subTtl + taxTtl;
                totalAmt = subTtl;
            }
            // console.log("totalAmt    ",totalAmt);return;
            console.log("difference before = ",self.difference);
            console.log("sub total before = ",self.sub_total);
            self.total = parseFloat(totalAmt).toFixed(2);
            if (self.receipt_amount == "" || self.receipt_amount == "-") {
                self.difference = 0;
            }else{
                // console.log(self.removeFormat(self.receipt_amount)+ '-'+ self.removeFormat(self.total));
                //if admin fee added then add in total instead of sub total
                var total_Amt = totalAmt.toFixed(2);
                if (self.admin_charge > 0) {
                    // receiptAmt += self.removeFormat(self.admin_charge);
                    self.receipt_amount = totalAmt;
                    // self.difference = self.removeFormat(receiptAmt) - self.removeFormat(self.total).toFixed(2);
                    var recptAmt = parseFloat(self.removeFormat(self.receipt_amount).toFixed(2));
                    var diffVal = recptAmt - parseFloat(total_Amt);
                    self.difference = diffVal;
                }else {
                    // self.difference = self.removeFormat(self.receipt_amount) - self.removeFormat(self.total).toFixed(2);
                    var recptAmt = parseFloat(self.removeFormat(self.receipt_amount).toFixed(2));
                    var diffVal = recptAmt - parseFloat(total_Amt);
                    self.difference = diffVal;
                }
            }
            console.log("difference sub total = ",self.difference);
            console.log("total == 2");
            if (self.totalDiscount > 0) {
                self.total = self.total - self.totalDiscount;
                self.difference = self.removeFormat(self.receipt_amount) - self.removeFormat(self.total);
                console.log("difference = ",self.difference);
                self.showTotalSummary = true;
            }
            // var oldDiff = self.difference;
            // oldDiff = self.removeFormat(self.difference);
            // oldDiff = oldDiff.toFixed(2);
            // self.difference = oldDiff;

        },
        // total_tax: function () {
        //     var self = this;
        //     var totalAmt = 0;
        //     if (self.admin_charge > 0) {
        //
        //         var subTtl = self.removeFormat(self.sub_total);
        //         var taxTtl = self.removeFormat(self.total_tax);
        //         var admCharge = self.removeFormat(self.admin_charge);
        //         totalAmt = subTtl + taxTtl + admCharge;
        //     }else{
        //
        //         var subTtl = self.removeFormat(self.sub_total);
        //         var taxTtl = self.removeFormat(self.total_tax);
        //         totalAmt = subTtl + taxTtl;
        //     }
        //     // console.log("totalAmt    ",totalAmt);return;
        //     var total_Amt = totalAmt.toFixed(2);
        //     self.total = parseFloat(total_Amt);
        //
        //     if (self.receipt_amount == "" || self.receipt_amount == "-") {
        //         self.difference = 0;
        //     } else {
        //
        //         var recptAmt = self.removeFormat(self.receipt_amount);
        //         var diffVal = recptAmt - parseFloat(total_Amt);
        //         self.difference = diffVal;
        //     }
        //         console.log("difference = ",self.difference);
        //     if (self.totalDiscount > 0) {
        //         self.total = self.removeFormat(self.total) - self.removeFormat(self.totalDiscount);
        //         self.difference = self.removeFormat(self.receipt_amount) - self.total;
        //         console.log("difference = ",self.difference);
        //     }
        // },
        bill_date: function (newVal,oldVal) {
            var self = this;
            //prevent watch call for first time in case of update
            if (self.$route.params.id > 0 && !self.watchCall) {
                //as vendor invoice created from sublet work order line item
                if (self.poDataFromWO != undefined) {
                    self.watchCall = true;
                }
                return;
            }else{
                if (self.vendor_id != null && self.vendor_id.term ){
                    var date = '';
                    if(self.vendor_id.term_period == 'month'){
                        date = moment(newVal, "MM/DD/YYYY")
                                .add(self.vendor_id.term,'month') //replace 2 with number of days you want to add

                    }else{

                        date = moment(newVal, "MM/DD/YYYY")
                                .add(self.vendor_id.term,'days')
                    }

                    self.due_date = date;

                }
            }
        },
        showCharges() {
            var self = this;
            if (self.showCharges) {
                //self.getPurchaseOrderChargesData();
            }
        },

        location_id:function(val){

            var self = this;
            self.part_search_error_msg = "";
             if (self.$route.params.id != undefined && self.accountCanChanged == false){
                return;
            }
            if (val.value != undefined){
                if (self.rows.length > 1){
                    if (self.is_misc_po == 0) {
                        for(var i=0;i < self.rows.length; i++){
                            self.rows[i].gl_account_id = '';
                        }
                    }
                }
            }
        },
        //get parse content of file
        filesArr: function (files) {

            var self = this;

            if (self.poInvoiceFromWO == undefined) {
                if ( files.length > 0 && files[0].type == 'application/pdf' ) {

                    const fields = new FormData();

                    for (var i = 0; i < self.filesArr.length; i++) {
                        let file = this.filesArr[i];
                        fields.append("files[]", file);
                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/bill/parse-file",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        dataType: "json",
                        success: function (data) {
                            self.$parent.loading = false;
                            if (data.status == "success") {
                                self.pdfArr = data.content;
                                console.log(self.pdfArr);
                                if (self.pdfArr.invDate != undefined && self.pdfArr.invDate != null && self.pdfArr.invDate != "" ) {
                                    self.valuesFound = true;
                                    if ( self.pdfArr.loadDetail ) {
                                        if (self.bill_date == "" || self.bill_date == null) {
                                            self.bill_date = moment(self.pdfArr.invDate,"MM/DD/YYYY");
                                        }
                                    }
                                }
                                if (self.pdfArr.invDueDate != undefined && self.pdfArr.invDueDate != null && self.pdfArr.invDueDate != "" ) {
                                    self.valuesFound = true;
                                    if ( self.pdfArr.loadDetail ) {
                                        if (self.due_date == "" || self.due_date == null) {
                                            self.due_date = moment(self.pdfArr.invDueDate,"MM/DD/YYYY");
                                        }
                                    }
                                }
                                if (self.pdfArr.invNo != undefined && self.pdfArr.invNo != null && self.pdfArr.invNo != "" ) {
                                    self.valuesFound = true;
                                    if ( self.pdfArr.loadDetail ) {
                                        if (self.bill_number == "" || self.bill_number == null) {
                                            self.bill_number = self.pdfArr.invNo;
                                        }
                                    }
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.$parent.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-parse-file');
                        }
                    });
                }
            }
        },
        receipt_amount: function(receipt_amount) {

          var self = this;
            var totalAmt = 0;
            if (self.admin_charge > 0) {
                // totalAmt = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax) + self.removeFormat(self.admin_charge);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                var admCharge = parseFloat(self.removeFormat(self.admin_charge).toFixed(2));
                // totalAmt = subTtl + taxTtl + admCharge;
                totalAmt = subTtl + admCharge;
            }else{
                // totalAmt = self.removeFormat(self.sub_total) + self.removeFormat(self.total_tax);
                var subTtl = parseFloat(self.removeFormat(self.sub_total).toFixed(2));
                // var taxTtl = parseFloat(self.removeFormat(self.total_tax).toFixed(2));
                // totalAmt = subTtl + taxTtl;
                totalAmt = subTtl;
            }
            self.total = totalAmt;
            if (self.receipt_amount == "" || self.receipt_amount == "-") {
                self.difference = 0;
            }else{
                // self.difference = self.removeFormat(self.receipt_amount) - self.removeFormat(self.total);
                var recptAmt = parseFloat(self.removeFormat(self.receipt_amount).toFixed(2));
                var diffVal = recptAmt -  parseFloat(totalAmt).toFixed(2);
                self.difference = diffVal;
            }
            console.log("difference sub total = ",self.difference);
            console.log("total == 2");
            if (self.totalDiscount > 0) {
                self.total = self.total - self.totalDiscount;
                self.difference = self.receipt_amount - self.total;
                console.log("difference = ",self.difference);
                self.showTotalSummary = true;
            }

        },

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }

            //set LoggedIn user's location as default location....
            if (userObj["location_id"] != null && userObj["location_id"] != '') {
                if ( userObj["locationName"] != undefined && userObj["locationCode"] != undefined ) {
                    self.location_id = {
                        value: userObj["location_id"],
                        text: self.titleCase(userObj["locationName"]) + " | " + userObj["locationCode"]
                    };
                }
            }
        }


        // self.getPermissions();

        //from work order view page
        if (self.poInvoiceFromWO != undefined) {
            self.loadFieldData(['taxes','location','vendor_po_charges']);
            console.log("MOUNTED IF ");
            self.vendor_inv_type = "sublet_invoice";
            self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
            self.rows = [];
            self.chrows = [];
            console.log(self.chargesArr);
            console.log(self.vendorInvDocOptionalArr);

            self.rows.push({
                bill_item_id:0,
                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                quantity_error_msg: "",
                unit_price: "",
                unit_price_error_msg: "",
                tax_percentage: 0,
                tax_percentage_error_msg: "",
                tax_amount_error_msg: "",
                amount: 0,
                total: 0,
                description: "",
                desc_error_msg: "",
                part: null,
                part_error_msg: "",
                tax_id:"",
                tax_amount:0,
                gl_account_id:null,
                gl_account_error_msg:"",
                amount_error_msg:"",
                enableTaxSelect:true,
                labor:0,
                labor_error_msg:"",
                materials:0,
                materials_error_msg:"",
                vehicle_id:null,
                wo_type:self.woType,
                vehicle_error_msg:"",
                wo_item_id:""
            });

            /*self.chrows.push({
                bill_item_id: 0,
                charge_id: null,
                charge_type_error_msg: "",
                quantity: 0,
                quantity_error_msg: "",
                unit_price: 0,
                unit_price_error_msg: "",
                amount: 0,
                description:"",
                desc_error_msg:"",
                disableChargeSelect:false,
                amount_error_msg:""
            });*/
            if (self.poDataFromWO != undefined) {
                if (self.poDataFromWO.poId != null) {
                    if (self.poDataFromWO.billId != null) {
                        self.woType = self.poDataFromWO.wo_type;
                        if (self.poDataFromWO.billId > 0) {
                            //Update Invoice From Work Order View
                            self.bill_id = self.poDataFromWO.billId;
                            self.loadBillDetail(self.bill_id);
                            self.isUpdate = true;
                        }else{
                            //Generate Invoice From Work Order View
                            var id = self.poDataFromWO.poId;
                            self.loadPurchaseOrder(id);
                            self.vendor_inv_type = "sublet_invoice";
                            self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                            setTimeout(function(){
                                self.loadPurchaseOrderItem(id);
                            },200);
                        }
                        if (self.woType == "default") {
                            self.vehicleId = self.poDataFromWO.vehicle_id;
                            self.woItemId = self.poDataFromWO.woItemId;
                        }
                    }

                }
            }
            self.showTotalSummary = true;

        }else{
        // if(self.$route.query.id != undefined){
            if (this.$route.query.data != '' && this.$route.query.data != undefined) {
            //   self.loadPurchaseOrder(self.$route.query.id);
            //     self.loadPurchaseOrderItem(self.$route.query.id);
                self.showMoreLessLabel = "Show Less"
                var webloc = window.location.href;

                var decodeStr = "";
                decodeStr = atob(this.$route.query.data)
                console.log("decodeStr ==", decodeStr);

                var url = new URL(webloc+"?"+decodeStr);
                var id = url.searchParams.get("id");
                var type = url.searchParams.get("type");
                var receipt_id = url.searchParams.get("receipt_id");

                self.redirectFrom = url.searchParams.get("redirectFrom");
                if (self.$parent.redirectFrom != undefined){
                    self.$parent.redirectFrom = url.searchParams.get("redirectFrom");
                    self.$parent.poId = id;
                }
                self.vendor_inv_type = type;
                if (self.vendor_inv_type == "sublet_po") {
                    self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                }
                if (self.vendor_inv_type == "misc") {//type not stored in vendor invoice
                    self.vendor_inv_type = "default";
                    self.vendor_invoice_type = {text:'Default' , value:'default'};
                }
                console.log("id :: " + id);
                console.log("type :: " + type);

                if(self.redirectFrom == "approveorder") {
                  self.loadFieldData(['taxes','location','mso_charges']);
                  self.order_id = url.searchParams.get("order_id");
                  console.log("order_id :: " + self.order_id);
                  self.vendor_inv_type = "equipment";
                  self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                  self.loadApproveOrder(self.order_id ,'with_add');
                } else if (self.redirectFrom == "receiptview" || self.redirectFrom == "receiptcreate" || self.redirectFrom == "poreceipttab") {
                    self.loadFieldData(['taxes','location','vendor_po_charges']);
                    self.receipt_id = receipt_id;
                    self.$parent.receipt_id = receipt_id;
                    self.loadPurchaseOrder(id);
                    self.loadReceiptItem(id,receipt_id);//receipt item with po charges
                }else {
                  self.loadFieldData(['taxes','location','vendor_po_charges']);
                  self.loadPurchaseOrder(id);
                  self.loadPurchaseOrderItem(id);
                }

            } else{
                //vendor invoice type equipment
                if (this.$route.params.inv_type != undefined){
                    if (this.$route.params.inv_type == "equipment"){
                        self.loadFieldData(['taxes','location','mso_charges']);
                    }else{
                        self.loadFieldData(['taxes','location','vendor_po_charges']);
                    }
                }else{
                    self.loadFieldData(['taxes','location','vendor_po_charges']);
                }
                var path = window.location.pathname;
                var segments = path.split("/");
                self.showMoreLessLabel = "Show Less"

                if (segments[3]) {

                    self.bill_id = segments[3];
                    self.loadBillDetail(segments[3]);
                    self.isUpdate = true;

                }else{

                    self.rows.push({
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        unit: "",
                        unit_id: "",
                        desc_error_msg: "",
                        unit_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        vehicle_id:null,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        unit: "",
                        unit_id: "",
                        desc_error_msg: "",
                        unit_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        vehicle_id:null,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        unit: "",
                        unit_id: "",
                        desc_error_msg: "",
                        unit_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        vehicle_id:null,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        unit: "",
                        unit_id: "",
                        desc_error_msg: "",
                        unit_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        vehicle_id:null,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        unit: "",
                        unit_id: "",
                        desc_error_msg: "",
                        unit_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        vehicle_id:null,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    });


                    /*self.disrows.push({
                        discount_id:0,
                        discount: 0,
                        description: "",
                        description_error_msg: "",
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        discount_error_msg:"",
                    });*/

                    self.chrows.push({
                        bill_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        unit:"",
                        desc_error_msg:"",
                        unit_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        unit:"",
                        desc_error_msg:"",
                        unit_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        unit:"",
                        desc_error_msg:"",
                        unit_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:null
                    });
                    if (self.vendor_inv_type == "default") {
                        self.chrows = [];
                    }

                    // var todayDate = self.getTodayDate();
                    // self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
                    // self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
                    // self.bill_date = moment(todayDate,"MM/DD/YYYY");

                }
            }
        }
    },
    methods:{

        addExcelRows:function(){
            var self = this;
            var clipText = self.excelRows;
            var dataArr = [];
            var accountArr = [];
            var unitArr = [];
            if (clipText != '') {

                var valueAdded = false;
                for(var i = 0;i<self.rows.length;i++) {
                    if (self.rows[i].gl_account_id != '' &&  self.rows[i].amount != 0 ){
                        valueAdded = true;
                    }
                }
                if(!valueAdded){
                    self.rows = [];
                }
            }else{
                return;
            }
            // var clipRows = clipText.split(String.fromCharCode(13));
            var clipRows = clipText.split('\n');

            for (var i=0; i<clipRows.length; i++) {
                // var clipData = clipRows[i].split(String.fromCharCode(9));
                var clipData = clipRows[i].split('\t');

                if (clipData[0] != ''){
                    dataArr.push({
                        gl_account_id:clipData[0],
                        amount:self.amountFormat(clipData[1]),
                        description:clipData[2],
                        vehicle_id:clipData[3]
                    });
                    accountArr.push(clipData[0]);
                    if (clipData[3] != ''){
                        unitArr.push(clipData[3]);
                    }
                }
                console.log(dataArr);
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/fetch-gl-unit-data",
                type: "POST",
                headers: this.ajxHeaders,
                data:{
                    unit:unitArr,
                    account:accountArr
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.gl != undefined) {
                        self.glAccountArr = data.gl;
                    }
                    if (data.unit != undefined) {
                        self.allVehicleArr = data.unit;
                    }

                    if (dataArr.length){
                        var glValue = '';
                        // var vehicle = '';
                        for (var j=0; j<dataArr.length; j++) {
                            var vehicle = '';
                            if (dataArr[j]['gl_account_id'] != undefined && dataArr[j]['gl_account_id'] != ''){
                                $.each(self.glAccountArr, function (key, value) {
                                    if (value.code == dataArr[j]['gl_account_id']) {
                                        glValue = {
                                            value: value.value,
                                            text: value.text,
                                        };
                                    }
                                });
                            }

                            if (dataArr[j]['vehicle_id'] != undefined && dataArr[j]['vehicle_id'] != ''){
                                $.each(self.allVehicleArr, function (key, value) {
                                    if (value.unit_no == dataArr[j]['vehicle_id']) {
                                        vehicle = {
                                            value: value.value,
                                            text: value.text
                                        };
                                    }
                                });
                            }

                            if (glValue != ''){
                                self.rows.push({
                                    bill_item_id:0,
                                    quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                    quantity_error_msg: "",
                                    unit_price: "",
                                    unit_price_error_msg: "",
                                    tax_percentage: 0,
                                    tax_percentage_error_msg: "",
                                    tax_amount_error_msg: "",
                                    amount:dataArr[j]['amount'],
                                    total: 0,
                                    description: dataArr[j]['description'],
                                    unit: "",
                                    unit_id: "",
                                    desc_error_msg: "",
                                    unit_error_msg: "",
                                    part: null,
                                    part_error_msg: "",
                                    tax_id:"",
                                    tax_amount:0,
                                    gl_account_id:glValue,
                                    gl_account_error_msg:"",
                                    amount_error_msg:"",
                                    enableTaxSelect:true,
                                    vehicle_id:vehicle,
                                    labor:0,
                                    labor_error_msg:"",
                                    materials:0,
                                    materials_error_msg:"",
                                    wo_type:self.woType,
                                    vehicle_error_msg:"",
                                    wo_item_id:""
                                });
                            }
                        }
                        self.calculateTaxSubTotal();

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.rows.push({
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        vehicle_id:null,
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    });
                    self.calculateTaxSubTotal();
                    self.generateStatusCodeMessage(jqXHR,false,'journal-by-id')
                }
            });

            self.excelRows = '';

        },

        changeType: function() {

          if(this.vendor_invoice_type.text != "Default" && this.order_id == '') {
            this.isChargeAvail = true;
          }
        },
        onChangepo(evt){
            console.log(evt.value);
            var path = window.location.pathname;
            var segments = path.split("/");
            if(!segments[3]){
                this.loadPurchaseOrder(evt.value);
                this.loadPurchaseOrderItem(evt.value);

            }

        },
        loadPurchaseOrderItem(id) {
          console.log("loadPurchaseOrderItem");
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-purchase-order/items/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.rows = [];
                        if (self.chrows.length  > 0) {

                        } else {
                          self.chrows = [];
                        }

                        var subletFoundArr = [];
                        var itemArr = [];
                        var vendor_po_type = "";
                        var receivedQtyArr = [];
                        if (data.received_qty != undefined && data.received_qty != null) {
                            var receivedQtyArr = data.received_qty;
                        }
                        if (data.content.length >= 1) {
                            var totalAmt = 0;
                            for (var i = 0; i < data.content.length; i++) {
                                vendor_po_type = data.content[i].vendor_po_type;
                                var poItemId = data.content[i].id;
                                var receivedQty = null;
                                var receiptArr = null;
                                var receiptItemCost = 0;
                                if (poItemId != null) {
                                    var itemObj = receivedQtyArr.find(item => item.po_item_id === poItemId);
                                    if (itemObj != undefined && itemObj != null) {
                                        receivedQty = itemObj.received_qty;
                                        if (itemObj.receipt_id != undefined && itemObj.receipt_id != null) {
                                            receiptArr = itemObj.receipt_id;
                                        }
                                        if (itemObj.cost != undefined && itemObj.cost != null) {
                                            receiptItemCost = itemObj.cost;
                                        }
                                    }
                                }
                                if (receiptItemCost == 0) {
                                    receiptItemCost = data.content[i].unit_price;
                                }
                                if (data.content[i].charge_id == null){
                                    var itemId = null;
                                    if (data.content[i].item_id != null) {
                                        itemId = {
                                            value: data.content[i].item_id,
                                            text: data.content[i].iCode + " | " + data.content[i].iName
                                        };
                                    }
                                    var unitName = "";
                                    if (data.content[i].unit_no != null && data.content[i].unit_no != "") {
                                        unitName = data.content[i].unit_no;
                                    }
                                    if (data.content[i].unit_name != null && data.content[i].unit_name != "") {
                                        unitName += " | ";
                                        unitName += data.content[i].unit_name;
                                    }

                                    self.rows.push({
                                        bill_item_id: 0,

                                        description: (self.vendor_inv_type == 'equipment')?data.content[i].vmCode + " | " + data.content[i].vmName:data.content[i].description,

                                        quantity: (receivedQty && receivedQty != null && receivedQty > 0) ? receivedQty : data.content[i].quantity,
                                        quantity_error_msg: "",

                                        unit_price: (vendor_po_type == 'item' || vendor_po_type == 'misc')?self.amountFormat(receiptItemCost):self.amountFormat(data.content[i].unit_price),
                                        unit_price_error_msg: "",
                                        tax_percentage: data.content[i].tax_percentage,
                                        tax_percentage_error_msg: "",
                                        tax_id:"",

                                        amount: (receivedQty && receivedQty != null && receivedQty > 0) ? self.amountFormat(receiptItemCost * receivedQty) : self.amountFormat(data.content[i].total),
                                        part: itemId,
                                        desc_error_msg:"",
                                        part_error_msg: "",
                                        gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                            value: data.content[i].gl_account_id,
                                            text: self.ucString(data.content[i].glCode + " | " + data.content[i].glDesc),
                                        } : null,
                                        gl_account_error_msg:"",
                                        vehicle_id: (data.content[i].item_vehicle_id != undefined && data.content[i].item_vehicle_id != null && data.content[i].item_vehicle_id != '')?{value: data.content[i].item_vehicle_id, text: self.titleCase(unitName),unit_no:data.content[i].unit_no}:null,
                                        labor:0,
                                        labor_error_msg:"",
                                        materials:(self.vendor_inv_type == 'sublet_invoice')?self.amountFormat(data.content[i].unit_price):0,
                                        materials_error_msg:"",
                                        wo_type:self.woType,
                                        vehicle_error_msg:"",
                                        wo_item_id:(data.content[i].wo_item_id != undefined && data.content[i].wo_item_id != null && data.content[i].wo_item_id != '')?data.content[i].wo_item_id:self.woItemId,
                                        receipt_arr:receiptArr
                                    })
                                }else{

                                    var chargeId = null;
                                    if (data.content[i].charge_id != null) {
                                        chargeId = {
                                            value: data.content[i].charge_id,
                                            text: data.content[i].charge_name
                                        };
                                    }

                                    //Sublet Labor and Sublet Part
                                    if (data.content[i].vendor_po_type == "sublet_po") {

                                        subletFoundArr.push(data.content[i].charge_identifier);

                                        itemArr.push({
                                            bill_item_id: 0,
                                            quantity: data.content[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price: self.amountFormat(data.content[i].unit_price),
                                            unit_price_error_msg: "",
                                            amount: self.amountFormat(data.content[i].total),
                                            charge_id: chargeId,
                                            description:data.content[i].description,
                                            desc_error_msg:"",
                                            disableChargeSelect:(data.content[i].charge_identifier != undefined
                                            && (data.content[i].charge_identifier == "sublet_labor" || data.content[i].charge_identifier == "sublet_part"))?true:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg:""
                                        });

                                    }else{
                                        self.chrows.push({
                                            bill_item_id: 0,
                                            quantity: data.content[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price: self.amountFormat(data.content[i].unit_price),
                                            unit_price_error_msg: "",
                                            amount: self.amountFormat(data.content[i].total),
                                            charge_id: chargeId,
                                            description:"",
                                            desc_error_msg:"",
                                            disableChargeSelect:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg:"",
                                            vehicle_id:null
                                        })
                                    }
                                }
                                //total in case of records receipt
                                if(receivedQty && receivedQty != null && receivedQty > 0){
                                    totalAmt += receivedQty * receiptItemCost;
                                }
                            }
                            // if (vendor_po_type == 'sublet_po') {
                            //     if (!self.chrows || self.chrows.length == 0){
                            //         self.chrows.push({
                            //             bill_item_id: 0,
                            //             charge_id: null,
                            //             charge_type_error_msg: "",
                            //             quantity: 0,
                            //             quantity_error_msg: "",
                            //             unit_price: 0,
                            //             unit_price_error_msg: "",
                            //             amount: 0,
                            //             description:"",
                            //             desc_error_msg:"",
                            //             disableChargeSelect:false,
                            //             amount_error_msg:"",
                            //             vehicle_id:null
                            //         });
                            //     }

                            // }else{
                                if (!self.chrows || self.chrows.length == 0){
                                    self.chrows.push({
                                        bill_item_id: 0,
                                        charge_id: null,
                                        charge_type_error_msg: "",
                                        quantity: 0,
                                        quantity_error_msg: "",
                                        unit_price: 0,
                                        unit_price_error_msg: "",
                                        amount: 0,
                                        description:"",
                                        desc_error_msg:"",
                                        disableChargeSelect:false,
                                        amount_error_msg:"",
                                        vehicle_id:null
                                    });
                                }
                            //}

                        } else {

                            var taskName = "";
                            var itemAmount = self.amount;
                            itemAmount = self.currentPOAmount;//po amount
                            if (self.poInvoiceFromWO != undefined) {

                                if (self.poDataFromWO != undefined && self.poDataFromWO != null) {

                                    if (self.poDataFromWO.vmrs_name != null && self.poDataFromWO.vmrs_name != "") {
                                        taskName += self.poDataFromWO.vmrs_name;
                                    }

                                    if (self.poDataFromWO.task_name != null && self.poDataFromWO.task_name != "") {
                                        taskName += " | ";
                                        taskName += self.poDataFromWO.task_name;
                                    }
                                    itemAmount = self.poDataFromWO.po_amount
                                }
                            }
                            self.rows.push({
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: self.amountFormat(itemAmount),
                                total: 0,
                                description:taskName,
                                unit: "",
                                unit_id: "",
                                desc_error_msg: "",
                                unit_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:self.amountFormat(itemAmount),
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:self.woItemId
                            });
                            //charge
                            self.chrows.push({
                                bill_item_id:0,
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                charge_id: null,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                charge_type_error_msg:"",
                                vehicle_id:null
                            })

                        }

                        self.showTotalSummary = true;

                        //multi unit work order create vendor invoice populate units from work order line items
                        if (self.poDataFromWO != undefined) {
                            if (self.poDataFromWO.poId != null) {
                                if (self.poDataFromWO.billId != null) {
                                    if (self.poDataFromWO.billId == 0) {
                                        if (self.woType == "multi unit" && self.vendor_inv_type == "sublet_invoice") {
                                            if (data.units != undefined && data.units != null) {
                                                var unitsArr = data.units;
                                                if (unitsArr.length > 0) {
                                                    self.rows = [];
                                                    for (var i = 0; i < unitsArr.length; i++) {
                                                        var vehicleId = {
                                                            text:unitsArr[i].unit_no,
                                                            value:unitsArr[i].vehicle_id,
                                                            unit_no:unitsArr[i].unit_no,
                                                        }
                                                        self.rows.push({
                                                            bill_item_id:0,
                                                            quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                                            quantity_error_msg: "",
                                                            unit_price: "",
                                                            unit_price_error_msg: "",
                                                            tax_percentage: 0,
                                                            tax_percentage_error_msg: "",
                                                            tax_amount_error_msg: "",
                                                            amount: self.amountFormat(itemAmount),
                                                            total: 0,
                                                            description:unitsArr[i].description,
                                                            unit: "",
                                                            unit_id: "",
                                                            desc_error_msg: "",
                                                            unit_error_msg: "",
                                                            part: null,
                                                            part_error_msg: "",
                                                            tax_id:"",
                                                            tax_amount:0,
                                                            gl_account_id:null,
                                                            gl_account_error_msg:"",
                                                            amount_error_msg:"",
                                                            enableTaxSelect:true,
                                                            vehicle_id:vehicleId,
                                                            labor:0,
                                                            labor_error_msg:"",
                                                            materials:self.amountFormat(unitsArr[i].amount),
                                                            materials_error_msg:"",
                                                            wo_type:self.woType,
                                                            vehicle_error_msg:"",
                                                            wo_item_id:unitsArr[i].wo_item_id
                                                        });
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        setTimeout(function(){
                            if(totalAmt > 0){
                                self.receipt_amount = self.amountFormat(totalAmt);
                                self.sub_total = self.amountFormat(totalAmt);
                            }
                        },1000);
                        setTimeout(function(){
                            //disable sublet invoice admin fee as requested by Anthony
                            if (self.poDataFromWO != undefined ) {
                                if (self.poDataFromWO.poId != null) {
                                    if (self.poDataFromWO.billId != null) {
                                        if ( self.poDataFromWO.billId == 0 ) {
                                            self.nationaleaseAdminFee();
                                        }
                                    }
                                }
                            }
                        },1000);
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-item')
                }
            });
        },
        loadApproveOrderItem(id , actionwith) {
          console.log("loadApproveOrderItem");
          var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/vendor-purchase-order/items/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    var isChargeReset = false;
                    self.isChargeAvail = true;
                    self.chrows = [];

                    data.content.forEach(element => {

                      if(element.charge_id != null && element.charge_id != "") {

                        if(isChargeReset == false) {
                          self.chrows = [];
                          isChargeReset = true;
                        }
                        self.isChargeAvail = true;
                        var chargeId = null;
                        chargeId = {
                            value: element.charge_id,
                            text: element.charge_name,
                            price: element.unit_price,
                        };
                        self.chrows.push({
                              bill_item_id: 0,
                              quantity: element.quantity,
                              quantity_error_msg: "",
                              unit_price: self.amountFormat(element.unit_price),
                              unit_price_error_msg: "",
                              amount: self.amountFormat(element.total),
                              charge_id: chargeId,
                              description:"",
                              desc_error_msg:"",
                              disableChargeSelect:true,
                              amount_error_msg:"",
                              charge_type_error_msg:"",
                              vehicle_id:null
                          })

                          if(actionwith == "with_add") {
                            self.receipt_amount += element.unit_price;

                            // self.po.amount = self.receipt_amount;
                            var poText =  self.po.text.split("|");
                            // var poAmount = self.removeCurrencyFormat(poText[1]);
                            // self.po.text = poText[0] + " | " + self.amountFormat(self.receipt_amount);
                        //     {
                        //     value: data.content.vendor_po_id,
                        //     type: data.content.type,
                        //     text: data.content.poNo + " | " + self.amountFormat(data.content.unit_price),
                        //     amount:data.content.unit_price
                        // }
                          }
                      }

                    });


                    var i = 0;
                    self.chrows.forEach(element => {
                      console.log("I ==" , i);
                      self.onChargeSelect(null,i);
                      i++;
                    });

                    if ( self.chrows.length > 0) {
                        self.showTotalSummary = true;
                    }else{
                      self.chrows.push({
                                bill_item_id:0,
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                charge_id: null,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:true,
                                amount_error_msg:"",
                                charge_type_error_msg:"",
                                vehicle_id:null
                            },{
                                bill_item_id:0,
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                charge_id: null,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:true,
                                amount_error_msg:"",
                                charge_type_error_msg:"",
                                vehicle_id:null
                            },{
                                bill_item_id:0,
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                charge_id: null,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:true,
                                amount_error_msg:"",
                                charge_type_error_msg:"",
                                vehicle_id:null
                            })
                        self.showTotalSummary = true;
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load')
                }
            });

        },
        loadPurchaseOrder(id) {
          console.log("loadPurchaseOrder");
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/purchaseorder/" + id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    console.log(data);

                    if (data.status == "success") {

                        self.isEdit = true;
                        if (self.$parent.poId != undefined){
                            self.$parent.poId = data.content.id;
                        }
                        self.po ={
                            value: data.content.id,
                            text: data.content.po_no + " | " + self.amountFormat(data.content.total),
                            amount:data.content.total
                        };
                        self.location_id={
                          value: data.content.assigned_loc_id,
                            text: data.content.assigned_loc_name
                        }
                        self.purchase_order_type = {
                            value: data.content.type,
                            text: self.titleCase(data.content.type)
                        };
                        if(data.content.payment_option_code != "" && data.content.payment_option_code != null) {
                            self.payment_type = {value: data.content.payment_option_code, text: data.content.payment_option_name};
                        }else{
                            self.payment_type = null;
                        }
                        //disable purchase order type drop down
                        // $("#purchase_order_type").addClass("disable-field");
                        self.disablePurchaseOrderTypeField = true;

                        // self.from_where = {value: data.content.from_where, text: self.titleCase(data.content.from_where) };
                        if (data.content.type == "item") {
                            self.showItemFields = true;
                        } else {
                            self.showItemFields = false;
                        }
                        if (data.content.type == "sublet_po") {
                            self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                            self.vendor_inv_type = "sublet_invoice";
                        }else if (data.content.type == "item") {
                            self.vendor_invoice_type = {text:'Item' , value:'item'};
                            self.vendor_inv_type = "item";
                        }else if (data.content.type == "equipment") {
                            self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                            self.vendor_inv_type = "equipment";
                        }else if (data.content.type == "misc") {
                            self.vendor_inv_type = "default";
                            self.vendor_invoice_type = {text:'Default' , value:'default'};
                            self.is_misc_po = 1;
                        }
                        //self.bill_date = data.content.order_date; no need to populate as it is different from po
                        self.due_date = data.content.due_date;
                        self.delivery_date = data.content.delivery_date;
                        self.attention = data.content.attention;
                        self.notes = data.content.notes;
                        // self.status = data.content.status;
                        self.status = {
                            value: data.content.status,
                            text: self.titleCase(data.content.status)
                        };
                        if (data.content.assigned_loc_id == null) {
                            self.assigned_location_id = null;
                        } else {
                            self.assigned_location_id = {
                                value: data.content.assigned_loc_id,
                                text: self.titleCase(data.content.assigned_loc_name + " (" + data.content.assigned_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ordering_loc_id == null) {
                            self.ordering_location_id = null;
                        } else {
                            self.ordering_location_id = {
                                value: data.content.ordering_loc_id,
                                text: self.titleCase(data.content.ordering_loc_name + " (" + data.content.ordering_loc_code +
                                    ")")
                            };
                        }

                        if (data.content.ship_loc_id == null) {
                            self.ship_to_location_id = null;
                        } else {
                            self.ship_to_location_id = {
                                value: data.content.ship_loc_id,
                                text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
                            };
                        }

                        // if (self.customer_id == null) {
                        //     self.customer_id="";
                        // } else{
                        //     if((data.content.cust_id)!=null)
                        //     {
                        //         var name=(data.content.cust_name != null)? data.content.cust_name :"";
                        //        var code=(data.content.cust_code != null)?data.content.cust_code:"";

                        //         self.customer_id={value: data.content.cust_id, text: self.titleCase(name + " (" + code +")")};
                        //     }
                        // }
                        if ((data.content.cust_id) != null) {
                            var name = (data.content.cust_name != null) ? data.content.cust_name : "";
                            var code = (data.content.cust_code != null) ? data.content.cust_code : "";

                            self.customer_id = {
                                value: data.content.cust_id,
                                text: self.titleCase(name + " (" + code + ")")
                            };
                        } else {
                            self.customer_id = null;
                        }

                        // if (self.sales_person_id == null) {
                        //     self.sales_person_id == "";
                        // } else{
                        //     if((data.content.sales_id)!=null)
                        //     {
                        //         var firstname=(data.content.sales_firstname != null)? data.content.sales_firstname :"";
                        //         var lastname=(data.content.sales_lastname != null)?data.content.sales_lastname:"";
                        //         self.sales_person_id={value: data.content.sales_id, text: self.titleCase(firstname + " " + lastname)};
                        //     }

                        // }
                        if ((data.content.sales_id) != null) {
                            var firstname = (data.content.sales_firstname != null) ? data.content.sales_firstname : "";
                            var lastname = (data.content.sales_lastname != null) ? data.content.sales_lastname : "";
                            self.sales_person_id = {
                                value: data.content.sales_id,
                                text: self.titleCase(firstname + " " + lastname)
                            };
                        } else {
                            self.sales_person_id = null;
                        }

                        if (data.content.vID == null) {
                            self.vendor_id = null;
                        } else {
                            var vendorTerm = '';
                            var vendorPeriod = '';
                            if (data.content.term != undefined && data.content.term != null && data.content.term != "") {
                                vendorTerm = data.content.term;
                            }
                            if (data.content.period != undefined && data.content.period != null && data.content.period != "") {
                                vendorPeriod = data.content.period;
                            }

                            if ( data.content.required_attachment == 0 && self.vendor_inv_type == "sublet_invoice" ) {
                                self.fileRequired = '';
                            }
                            self.vendor_id = {
                                value: data.content.vID,
                                text: self.titleCase(data.content.vName + " |" + data.content.vCode + data.content.address),
                                code: data.content.vCode,
                                required_attachment:data.content.required_attachment
                            };
                            //populate due date on basis of vendor terms
                            if (vendorTerm != '' && vendorPeriod != '') {
                                self.vendor_id.term_period = vendorPeriod;
                                self.vendor_id.term = vendorTerm;
                                var dueDt = '';
                                if(self.vendor_id.term_period == 'month'){
                                    dueDt = moment(self.bill_date, "MM/DD/YYYY")
                                            .add(self.vendor_id.term,'month') //replace 2 with number of days you want to add

                                }else{

                                    dueDt = moment(self.bill_date, "MM/DD/YYYY")
                                            .add(self.vendor_id.term,'days');
                                }
                                //populate due date on the basis of terms if due date is blank
                                if (dueDt != "") {
                                    self.due_date = dueDt;
                                }
                            }
                        }

                        if (data.content.assigneeId == null) {
                            self.assignee = null;
                        } else {
                            self.assignee = {
                                value: data.content.assigneeId,
                                text: self.titleCase(data.content.assignee_name + " |" + data.content.assignee_code + data.content.assignee_address)
                            };
                        }

                        self.showCharges = true;
                        self.sub_total = data.content.sub_total;
                        // if (data.content.tax_amount != undefined){
                        //     self.total_tax = data.content.tax_amount.toFixed(2);
                        // }
                        // self.total_tax = data.content.total_tax;
                        self.total = data.content.total;
                        self.receipt_amount = data.content.total;
                        self.difference = self.receipt_amount - self.total;
                        console.log("difference = ",self.difference);
                        self.amount = data.content.total;
                        self.currentPOAmount = data.content.total;//Current PO Amount
                        if (self.poInvoiceFromWO != undefined) {
                            // self.disableVendorPOField = true;
                            self.disablePOField = true;
                        }else{
                            self.disableVendorPOField = false;
                            self.disablePOField = false;
                        }
                        if (data.content.type == "misc") {
                            self.disablePOField = true;
                        }
                        if (data.content.bill_number && data.content.bill_number != null && data.content.bill_number != ''){
                            self.bill_number = data.content.bill_number;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load')
                }
            });
        },
        loadBillDetail(bill_id) {
          console.log("loadBillDetail");

            var self = this;
            self.$parent.loading = true;


            $.ajax({
                url: process.env.ROOT_API + "/bill-detail/" + bill_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;

                    if(data.status == "success" && data.content.id == undefined){    
                        self.$swal({
                            title: 'This Vendor Invoice Not Available.',
                            type: 'info',
                            confirmButtonText: 'OK',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.BackBillList();
                            }
                        });
                    } else if (data.status == "success") {
                        self.vendor_id = {
                            value: data.content.vID,
                            text: self.titleCase(data.content.vName + " | " + data.content.vCode+data.content.address),
                            term_period:data.content.term_period,
                            term:data.content.term,
                            po_required:data.content.po_required,
                            code:data.content.vCode,
                            required_attachment:data.content.required_attachment
                        };
                        //if type is sublet and vendor not required upload file then make it optional like NTLS, VVG
                        if ( data.content.required_attachment == 0 && data.content.type == "sublet_invoice" ) {
                            self.fileRequired = '';

                        }
                        if(data.content.monthly_payable == 1){
                            self.fetchVendorGL();
                        }else{
                            self.vendorGLAccounts = [];
                        }
                        if ( data.content.po_required == 1 ) {
                            self.isPORequired = true;
                            self.poRequiredClass = 'required';
                        }else{
                            self.isPORequired = false;
                            self.poRequiredClass = '';
                        }
                        self.bill_date = data.content.bill_date;
                        self.due_date = data.content.due_date;
                        self.bill_number = data.content.bill_number;
                        self.notes = data.content.bill_notes;
                        self.reference = data.content.reference;
                        self.voucher = data.content.voucher_number;
                        if(data.content.app_ven_po_id != null) {
                          self.order_id = data.content.app_ven_po_id;
                        }
                        if(data.content.payment_type != "" && data.content.payment_type != null) {
                            self.payment_type = {value: data.content.payment_type_code, text: data.content.payment_type};
                        }else{
                            self.payment_type = null;
                        }
                        if(data.content.wo_data != undefined && data.content.wo_data != null) {
                            if (data.content.wo_data.wo_type != undefined && data.content.wo_data.wo_type != null) {
                                self.woType = data.content.wo_data.wo_type;
                                if (self.woType == "default") {
                                    if (data.content.wo_data.wo_vehicle_id != undefined && data.content.wo_data.wo_vehicle_id != null) {
                                        self.vehicleId = data.content.wo_data.wo_vehicle_id;
                                        self.woItemId = data.content.wo_data.wo_item_id;
                                    }
                                }
                            }
                        }

                        if (data.content.vendor_assignee_id != undefined && data.content.vendor_assignee_id != null) {
                            self.assignee = {
                                text:self.titleCase(data.content.assignee_name + " | " + data.content.assignee_code),
                                value:data.content.vendor_assignee_id
                            }
                        }else{
                            self.assignee = "";
                        }
                        if (data.content.po_type != undefined) {
                            if (data.content.po_type != null && data.content.po_type != "") {
                                self.vendor_inv_type = data.content.po_type;
                                if (data.content.po_type == "sublet_po") {
                                    self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                                    self.vendor_inv_type = "sublet_invoice";
                                }else if (data.content.po_type == "item") {
                                    self.vendor_invoice_type = {text:'Item' , value:'item'};
                                    self.vendor_inv_type = "item";
                                }else if (data.content.po_type == "equipment") {
                                    self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                                    self.vendor_inv_type = "equipment";
                                } else if (data.content.po_type == "equipment-osr") {
                                    self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                                    self.vendor_inv_type = "equipment";
                                } else if (data.content.po_type == "misc") {//type not stored in vendor invoice
                                    self.vendor_invoice_type = {text:'Default' , value:'default'};
                                    self.vendor_inv_type = "default";
                                    self.is_misc_po = 1;
                                }
                            }else{
                                if (data.content.type == "sublet_invoice") {
                                    self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                                    self.vendor_inv_type = "sublet_invoice";
                                }else if (data.content.type == "item") {
                                    self.vendor_invoice_type = {text:'Item' , value:'item'};
                                    self.vendor_inv_type = "item";
                                }else if (data.content.type == "equipment") {
                                    self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                                    self.vendor_inv_type = "equipment";
                                }else if (data.content.type == "refund") {
                                    self.vendor_invoice_type = {text:'Refund' , value:'refund'};
                                    self.vendor_inv_type = "refund";
                                }else{
                                    self.vendor_inv_type = "default";
                                    self.vendor_invoice_type = {text:'Default' , value:'default'};
                                }
                            }
                        }else{
                            if (data.content.type == "sublet_invoice") {
                                self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                                self.vendor_inv_type = "sublet_invoice";
                            }else if (data.content.type == "item") {
                                self.vendor_invoice_type = {text:'Item' , value:'item'};
                                self.vendor_inv_type = "item";
                            }else if (data.content.type == "equipment") {
                                self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                                self.vendor_inv_type = "equipment";
                            }else if (data.content.type == "refund") {
                                self.vendor_invoice_type = {text:'Refund' , value:'refund'};
                                self.vendor_inv_type = "refund";
                            }else{
                                self.vendor_inv_type = "default";
                                self.vendor_invoice_type = {text:'Default' , value:'default'};
                            }
                        }
                        self.disableInvType = true;
                        self.default_status = data.content.status;
                        //not allow to edit if status is approved
                        // if ( data.content.status == "approved" || data.content.type == "debt_note" ) {
                        if ( data.content.type == "debt_note" ) {
                            self.$parent.cantAccessPage = false;
                            return;
                        }

                        /*self.status = {
                            value: data.content.status,
                            text: self.titleCase(data.content.statusName)
                        };

                        if ( data.content.status == "paid") {
                            self.disableStatusField = true;
                        }else{
                            self.disableStatusField = false;
                        }*/

                        if (data.content.poId){

                            if (self.$parent.poId != undefined){
                                self.$parent.poId = data.content.poId;
                            }

                            self.po = {
                                value: data.content.poId,
                                text: data.content.poNumber+ ' | '+self.amountFormat(data.content.poTotal),
                                amount:data.content.poTotal
                            };
                        }else{
                            self.po = "";
                        }
                        if (data.content.locName != null && data.content.locName != "") {
                            self.location_id = {value:data.content.location_id,text:self.ucString(data.content.locName) + " | " + data.content.locCode};
                        }else{
                            self.location_id = "";
                        }
                        setTimeout(function(){
                            self.accountCanChanged = true;
                        },2000);

                        self.loadBillItems();

                        /*setTimeout(function(){
                            self.loadBillDiscount();
                        },500);*/

                        self.sub_total = data.content.sub_total;
                        // if (data.content.tax_amount != undefined){
                        //     self.total_tax = self.amountFormat(data.content.tax_amount);
                        // }
                        self.total = self.amountFormat(data.content.total);
                        self.receipt_amount = self.amountFormat(data.content.total);
                        self.difference = self.removeFormat(self.receipt_amount) - self.removeFormat(self.total);
                        console.log("difference = ",self.difference);
                        // self.existFilesArr = data.content.docs;
                        if (data.content.docs != null){
                            self.dropZonePreviewFiles = data.content.docs;
                            self.loadFilesPreview();
                        }else{
                            self.docArr = [];
                            self.validateDocs = [];
                            self.filesArr = [];
                        }
                        setTimeout(function(){
                            self.watchCall = true;
                        },500);
                        if (self.poInvoiceFromWO != undefined) {
                            // self.disableVendorPOField = true;
                            self.disablePOField = true;
                        }else{
                            if (data.content.type == "sublet_invoice") {
                                // self.disableVendorPOField = true;
                                self.disablePOField = true;
                            }else{
                                self.disableVendorPOField = false;
                                self.disablePOField = false;
                            }
                        }
                        if (data.content.type == "default" && self.is_misc_po == 1) {
                            // self.disableVendorPOField = true;
                            self.disablePOField = true;
                        }
                        if (data.content.post_period != undefined && data.content.post_period != "") {
                            self.postPeriod = data.content.post_period;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-details');
                }
            });
        },
        loadBillItems() {
          console.log("loadBillItems");
            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/item/" + self.bill_id,
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.status == "success") {

                        self.rows = [];
                        self.chrows = [];
                        self.chargesUnitArr = [];
                        var subletFoundArr = [];
                        var itemArr = [];
                        var newItem = 0;
                        if (data.content.length >= 1) {
                            for (var i = 0; i < data.content.length; i++) {
                                 if (data.content[i].charge_id == null){
                                    var itemId = null;
                                    if (data.content[i].iId != null) {
                                        itemId = {
                                            value: data.content[i].iId,
                                            text: data.content[i].iCode + " | " + data.content[i].iName
                                        };
                                    }

                                    if(data.content[i].unit_no != "" && data.content[i].unit_no != null) {
                                      self.order_id = data.content[i].app_po_id;
                                    //   self.vendor_inv_type = "equipment";
                                    //   self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                                      if(self.order_id != null && self.order_id != "") {
                                        self.loadApproveOrder(self.order_id, 'with_edit');
                                      }
                                    }
                                    var unitName = "";
                                    if (data.content[i].veh_unit_no != null && data.content[i].veh_unit_no != "") {
                                        unitName = data.content[i].veh_unit_no;
                                    }
                                    if (data.content[i].unit_name != null && data.content[i].unit_name != "") {
                                        unitName += " | ";
                                        unitName += data.content[i].unit_name;
                                    }
                                    if (self.vendor_inv_type == 'equipment') {
                                        if (data.content[i].vehicle_id != null && data.content[i].vehicle_id != "") {
                                            if (data.content[i].veh_unit_no != null && data.content[i].veh_unit_no != "") {
                                                self.chargesUnitArr.push({text:data.content[i].veh_unit_no,value:data.content[i].vehicle_id});
                                            }
                                        }
                                    }
                                    self.rows.push({
                                        bill_item_id:data.content[i].id,
                                        part:itemId,
                                        description:data.content[i].description,
                                        desc_error_msg:"",
                                        quantity:(data.content[i].item_qty > 0 || data.content[i].item_qty < 0 )?data.content[i].item_qty:"",
                                        quantity_error_msg:"",
                                        unit_price:(data.content[i].item_price > 0 )?self.amountFormat(data.content[i].item_price):"",
                                        unit_price_error_msg:"",
                                        unit: data.content[i].unit_no,
                                        amount:self.amountFormat(data.content[i].item_total + data.content[i].tax),
                                        tax_id:(data.content[i].tax_id != undefined && data.content[i].tax_id != null && data.content[i].tax_id != '') ? {
                                            value: data.content[i].tax_id,
                                            text: data.content[i].tax_name,
                                            percentage:data.content[i].tax_percentage,
                                        } : "",
                                        tax_amount:data.content[i].tax,
                                        total:data.content[i].item_total + data.content[i].tax,
                                        gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                            value: data.content[i].gl_account_id,
                                            text: self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc),
                                        } : null,
                                        gl_account_error_msg:"",
                                        amount_error_msg:"",
                                        enableTaxSelect:(data.content[i].item_qty > 0 || data.content[i].item_price)?false:true,
                                        vehicle_id: (data.content[i].vehicle_id != undefined && data.content[i].vehicle_id != null && data.content[i].vehicle_id != '')?{value: data.content[i].vehicle_id, unit_no: self.titleCase(unitName),text:self.titleCase(unitName)}:null,
                                        labor:0,
                                        labor_error_msg:"",
                                        materials:0,
                                        materials_error_msg:"",
                                        wo_type:self.woType,
                                        vehicle_error_msg:"",
                                        wo_item_id:""
                                    });

                                }else{
                                    //Sublet Labor and Sublet Part
                                    if (data.content[i].bill_type == "sublet_invoice") {
                                        var itemId = null;
                                        if (data.content[i].iId != null) {
                                            itemId = {
                                                value: data.content[i].iId,
                                                text: data.content[i].iCode + " | " + data.content[i].iName
                                            };
                                        }
                                        if ( data.content[i].charge_identifier != null && (data.content[i].charge_identifier.toLowerCase() == "admin" || data.content[i].charge_identifier.toLowerCase() == "nationalease_admin_fee")) {
                                            self.admin_charge += data.content[i].item_total;
                                        }
                                        subletFoundArr.push(data.content[i].charge_identifier);

                                        if (data.content[i].type != undefined) {
                                            if (data.content[i].type == "item") {
                                                var unitName = "";
                                                if (data.content[i].unit_no != null && data.content[i].unit_no != "") {
                                                    unitName = data.content[i].unit_no;
                                                }
                                                if (data.content[i].bill_item_id == 0) {
                                                    newItem = 1;
                                                }
                                                self.rows.push({
                                                    bill_item_id:data.content[i].bill_item_id,
                                                    quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                                    quantity_error_msg: "",
                                                    unit_price: "",
                                                    unit_price_error_msg: "",
                                                    tax_percentage: 0,
                                                    tax_percentage_error_msg: "",
                                                    tax_amount_error_msg: "",
                                                    amount: 0,
                                                    total: 0,
                                                    description: data.content[i].description,
                                                    desc_error_msg: "",
                                                    part: null,
                                                    part_error_msg: "",
                                                    tax_id:"",
                                                    tax_amount:0,
                                                    gl_account_id:null,
                                                    gl_account_error_msg:"",
                                                    amount_error_msg:"",
                                                    enableTaxSelect:true,
                                                    vehicle_id:(data.content[i].vehicle_id != undefined && data.content[i].vehicle_id != null && data.content[i].vehicle_id != '')?{value:data.content[i].vehicle_id,unit_no:unitName,text:unitName}:null,
                                                    labor:(data.content[i].labor_price != undefined && data.content[i].labor_price != null)?self.amountFormat(data.content[i].labor_price):0,
                                                    labor_error_msg:"",
                                                    labor_item_id:(data.content[i].labor_item_id != undefined && data.content[i].labor_item_id != null)?data.content[i].labor_item_id:"",
                                                    labor_charge_id:(data.content[i].labor_charge_id != undefined && data.content[i].labor_charge_id != null)?data.content[i].labor_charge_id:"",
                                                    materials:(data.content[i].part_price != undefined && data.content[i].part_price != null)?self.amountFormat(data.content[i].part_price):0,
                                                    materials_error_msg:"",
                                                    part_item_id:(data.content[i].part_item_id != undefined && data.content[i].part_item_id != null)?data.content[i].part_item_id:"",
                                                    part_charge_id:(data.content[i].part_charge_id != undefined && data.content[i].part_charge_id != null)?data.content[i].part_charge_id:"",
                                                    wo_type:self.woType,
                                                    vehicle_error_msg:"",
                                                    wo_item_id:(data.content[i].wo_item_id != undefined && data.content[i].wo_item_id != null && data.content[i].wo_item_id != "")?data.content[i].wo_item_id:""
                                                });
                                            }else{//charge
                                                var chargeId = null;
                                                if (data.content[i].charge_id != null) {
                                                    chargeId = {
                                                        value: data.content[i].charge_id,
                                                        text: data.content[i].charge_name
                                                    };
                                                }
                                                self.chrows.push({
                                                    bill_item_id:data.content[i].id,
                                                    charge_id:chargeId,
                                                    quantity:(data.content[i].item_qty != 0 )?data.content[i].item_qty:"",
                                                    quantity_error_msg:"",
                                                    unit_price:(data.content[i].item_price > 0 )?self.amountFormat(data.content[i].item_price):"",
                                                    unit_price_error_msg:"",
                                                    amount:self.amountFormat(data.content[i].item_total + data.content[i].tax),
                                                    total:data.content[i].item_total + data.content[i].tax,
                                                    description:"",
                                                    desc_error_msg:"",
                                                    disableChargeSelect:false,
                                                    amount_error_msg:"",
                                                    charge_type_error_msg:"",
                                                    vehicle_id:null
                                                });
                                            }
                                        }
                                    }else{
                                        var chargeId = null;
                                        var vehicleId = null;
                                        if (data.content[i].vehicle_id != null && data.content[i].vehicle_id != "") {
                                            if (data.content[i].veh_unit_no != null && data.content[i].veh_unit_no != "") {
                                                vehicleId = {text:data.content[i].veh_unit_no,value:data.content[i].vehicle_id};
                                            }
                                        }
                                        if (data.content[i].charge_id != null) {
                                            chargeId = {
                                                value: data.content[i].charge_id,
                                                text: data.content[i].charge_name
                                            };
                                        }
                                        self.chrows.push({
                                            bill_item_id:data.content[i].id,
                                            charge_id:chargeId,
                                            quantity:(data.content[i].item_qty != 0 )?data.content[i].item_qty:"",
                                            quantity_error_msg:"",
                                            unit_price:(data.content[i].item_price > 0 )?self.amountFormat(data.content[i].item_price):"",
                                            unit_price_error_msg:"",
                                            amount:(data.content[i].item_total + data.content[i].tax).toFixed(2),
                                            total:data.content[i].item_total + data.content[i].tax,
                                            description:"",
                                            desc_error_msg:"",
                                            disableChargeSelect:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg:"",
                                            vehicle_id:(self.vendor_inv_type == 'equipment')?vehicleId:null
                                        });

                                        /*if(self.order_id != '') {
                                          self.po.value += data.content[i].item_price;
                                        }*/
                                    }

                                }
                            }

                            if (self.vendor_inv_type == 'sublet_invoice') {
                                console.log(subletFoundArr);
                                console.log(itemArr);

                                //if no charge found in sublet invoice
                                if (!self.chrows || self.chrows.length == 0) {
                                    self.chrows.push({
                                        bill_item_id: 0,
                                        charge_id: null,
                                        charge_type_error_msg: "",
                                        quantity: 0,
                                        quantity_error_msg: "",
                                        unit_price: 0,
                                        unit_price_error_msg: "",
                                        amount: 0,
                                        description:"",
                                        desc_error_msg:"",
                                        disableChargeSelect:false,
                                        amount_error_msg:"",
                                        vehicle_id:null
                                    });
                                }

                            }else{
                              console.log("22 ==", self.order_id);
                                if (!self.chrows || self.chrows.length == 0){
                                    self.chrows.push({
                                        bill_item_id: 0,
                                        charge_id: null,
                                        charge_type_error_msg: "",
                                        quantity: 0,
                                        quantity_error_msg: "",
                                        unit_price: 0,
                                        unit_price_error_msg: "",
                                        amount: 0,
                                        description:"",
                                        desc_error_msg:"",
                                        disableChargeSelect:false,
                                        amount_error_msg:"",
                                        vehicle_id:null
                                    });
                                }
                            }

                        }else{

                          console.log("11 ==", self.order_id);

                            self.rows.push({
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            });


                            self.chrows.push({
                                bill_item_id:0,
                                charge_id:null,
                                quantity:'',
                                quantity_error_msg:"",
                                unit_price:"",
                                unit_price_error_msg:"",
                                amount:0,
                                total:'',
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                charge_type_error_msg:"",
                                vehicle_id:null
                            });
                        }
                        if (self.vendor_inv_type == "default") {
                            self.chrows = [];
                        }

                        if(self.chrows.length > 0) {
                          console.log("1" , self.order_id);
                          self.isChargeAvail = true;
                        }

                        if (self.vendor_inv_type == 'sublet_invoice') {
                            self.showTotalSummary = true;

                            //if (newItem == 0) {
                                self.calculateSubletInvoice();
                                self.calculateTaxSubTotal();
                            //}
                        }else{

                            self.showTotalSummary = true;

                        }

                    }




                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-items');
                }
            });
        },
        loadBillDiscount() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bill/discount-item/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.status == "success") {

                        self.disrows = [];

                        if (data.content.length >= 1) {
                            var totalDiscount = 0;
                            for (var i = 0; i < data.content.length; i++) {
                                self.disrows.push({
                                    discount_id:data.content[i].id,
                                    description:data.content[i].description,
                                    description_error_msg:"",
                                    discount:parseFloat(data.content[i].discount),
                                    discount_error_msg:"",
                                    gl_account_id:(data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '') ? {
                                        value: data.content[i].gl_account_id,
                                        text: self.ucString(data.content[i].accCode + " | " + data.content[i].accDesc),
                                    } : null,
                                    gl_account_error_msg:"",
                                });

                                totalDiscount += parseFloat(data.content[i].discount);
                            }
                            self.totalDiscount = totalDiscount;
                            self.total -= self.totalDiscount;

                        }else{

                            self.disrows.push({
                                discount_id:0,
                                description:'',
                                description_error_msg:"",
                                discount:0,
                                discount_error_msg:"",
                                gl_account_id:'',
                                gl_account_error_msg:"",
                            });
                        }
                        if ( self.disrows.length > 1) {
                            self.showTotalSummary = true;
                        }
                    }

                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-discount');
                }
            });
        },
        handleFilesUpload: function(event) {
            /* Get the uploaded files from the input.*/
            var self = this;
            if (!self.isUpdate) {

                self.filesArr = [];
                self.fileerroor_msg = "";

                let uploadedFiles = "";
                self.uploadBtn= "Uploading...";
                uploadedFiles = self.$refs.files.files;
                for (var i = 0; i < uploadedFiles.length; i++) {

                    this.filesArr.push(uploadedFiles[i]);

                }
                console.log(this.filesArr);
                this.$refs.files.value = '';
                self.uploadBtn= "Upload";
            }else{

                if ( self.existFilesArr.length > 0 ) {

                    if (confirm('Do you want to upload file? ')) {
                        self.filesArr = [];
                        self.fileerroor_msg = "";

                        let uploadedFiles = "";
                        self.uploadBtn= "Uploading...";
                        uploadedFiles = self.$refs.files.files;
                        for (var i = 0; i < uploadedFiles.length; i++) {

                            this.filesArr.push(uploadedFiles[i]);

                        }
                        console.log(this.filesArr);
                        this.$refs.files.value = '';
                        self.uploadBtn= "Upload";
                        self.isUpdate = false;
                    }

                }else{
                    self.isUpdate = false;
                    self.filesArr = [];
                    self.fileerroor_msg = "";

                    let uploadedFiles = "";
                    self.uploadBtn= "Uploading...";
                    uploadedFiles = self.$refs.files.files;
                    for (var i = 0; i < uploadedFiles.length; i++) {

                        this.filesArr.push(uploadedFiles[i]);

                    }
                    console.log(this.filesArr);
                    this.$refs.files.value = '';
                    self.uploadBtn= "Upload";
                }

            }

        },
        deleteDoc: function(id,key) {
            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {
                self.submitBtn = false;
                console.log( self.$refs.files);
                this.filesArr.splice(key,1)
                self.$refs.files.value = '';
                if (self.valuesFound) {
                    self.valuesFound = false;
                    self.matchingValuesError = [];
                }
            }

            return;

        },
        calculateAmount($event, index) {
            // alert(index);
            var self = this;
            if (self.rows[index].quantity == 0 || self.rows[index].unit_price == 0 || self.rows[index].quantity == null ||
                self.rows[index].unit_price == null) {
                self.rows[index].tax_percentage = 0;
            }

            if ( self.rows[index].quantity > 0 || self.rows[index].unit_price > 0 ) {
                self.rows[index].enableTaxSelect = false;
            }else{
                self.rows[index].enableTaxSelect = true;
            }
            self.calculateTaxSubTotal();

        },
        taxPercentage($event, index) {
            var self = this;

            if (self.rows[index].quantity && self.rows[index].unit_price) {
                self.calculateTaxSubTotal();
            } else {
                self.rows[index].tax_percentage = "";
                if (self.rows[index].quantity == null || !self.rows[index].quantity) {
                    self.rows[index].quantity_error_msg = "Quantity is Required.";
                }
                if (self.rows[index].unit_price == null || !self.rows[index].unit_price) {
                    self.rows[index].unit_price_error_msg = "Unit Price is Required.";
                }
            }

        },
        onSearchComponent(search, loading) {
            var self = this;
            if (search.length > 0 && self.location_id != null && self.location_id.value) {
                loading(true);
                    self.searchField(loading, search, 'exist component', self.location_id.value);
            }else{
              self.part_search_error_msg = "Please select the location first to get the part(s)."
            }
        },
        onSearchVendor(search, loading) {
            var self = this;
            self.po_error_msg = "";
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'bill_vendor', '');
            }
        },
        onTaxSelect(event,index) {
            var self = this;
            // alert(self.rows[index].tax_id.percentage);
            if( self.rows[index].tax_id != null && self.rows[index].tax_id != ""){
                self.rows[index].tax_amount =  parseFloat(( self.rows[index].amount * self.rows[index].tax_id.percentage ) / 100);
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
                self.rows[index].amount = parseFloat(self.rows[index].amount) + self.rows[index].tax_amount;
            }else{
                self.rows[index].tax_amount = 0;
                // self.rows[index].amount = self.rows[index].amount;
                self.rows[index].total = self.rows[index].amount + self.rows[index].tax_amount;
                self.rows[index].amount = parseFloat(self.rows[index].amount) + self.rows[index].tax_amount;
            }

            self.calculateTaxSubTotal();
        },
        addRow: function () {

            var self = this;
            var index = self.rows.length - 1;
            var error = false;

            // no validation required while adding new line
            self.rows.push({
                bill_item_id:0,
                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                quantity_error_msg: "",
                unit_price: "",
                unit_price_error_msg: "",
                tax_percentage: 0,
                tax_percentage_error_msg: "",
                tax_amount: 0,
                tax_amount_error_msg: "",
                amount: 0,
                total: 0,
                description: "",
                desc_error_msg: "",
                part: null,
                part_error_msg: "",
                tax_id:"",
                gl_account_id:null,
                gl_account_error_msg:"",
                amount_error_msg:"",
                enableTaxSelect:true,
                vehicle_id:null,
                labor:0,
                labor_error_msg:"",
                materials:0,
                materials_error_msg:"",
                wo_type:self.woType,
                vehicle_error_msg:"",
                wo_item_id:""
            });
            // if (self.rows.length < 1) {
            //     self.rows.push({
            //         bill_item_id:0,
            //         quantity: (self.vendor_inv_type == "sublet_invoice") ? 1 : "",
            //         quantity_error_msg: "",
            //         unit_price: "",
            //         unit_price_error_msg: "",
            //         tax_percentage: 0,
            //         tax_percentage_error_msg: "",
            //         tax_amount: 0,
            //         tax_amount_error_msg: "",
            //         amount: 0,
            //         total: 0,
            //         description: "",
            //         desc_error_msg: "",
            //         part: null,
            //         part_error_msg: "",
            //         tax_id:"",
            //         gl_account_id:null,
            //         gl_account_error_msg:"",
            //         amount_error_msg:"",
            //         enableTaxSelect:true,
            //         vehicle_id:null,
            //         labor:0,
            //         labor_error_msg:"",
            //         materials:0,
            //         materials_error_msg:"",
            //         wo_type:self.woType,
            //         vehicle_error_msg:"",
            //         wo_item_id:""
            //     });
            // }else{
            //     self.rows[index].quantity_error_msg = "";
            //     self.rows[index].unit_price_error_msg = "";
            //     self.rows[index].part_error_msg = "";
            //     self.rows[index].desc_error_msg = "";
            //     self.rows[index].gl_account_error_msg = "";
            //     self.rows[index].amount_error_msg = "";
            //     self.rows[index].labor_error_msg = "";
            //     self.rows[index].materials_error_msg = "";
            //     self.rows[index].vehicle_error_msg = "";

            //     if( String(self.rows[index].quantity).includes(':')){

            //         var quant = self.rows[index].quantity.split(':');
            //         self.rows[index].quantity = quant[0];
            //     }

            //     if (self.vendor_inv_type != "sublet_invoice") {
            //         if (self.rows[index].amount == null || self.rows[index].amount == "" ) {
            //             self.rows[index].amount_error_msg = "Amount Required.";
            //             error = true;
            //         }
            //     }
            //     if (self.vendor_inv_type == "item" || self.vendor_inv_type == "equipment") {
            //         if (self.rows[index].quantity == '' || self.rows[index].quantity == 0 ) {
            //             self.rows[index].quantity_error_msg = "Quantity Required.";
            //             error = true;
            //         }
            //         if (self.rows[index].unit_price == '' || self.rows[index].unit_price == 0 ) {
            //             self.rows[index].unit_price_error_msg = "Unit Price Required.";
            //             error = true;
            //         }
            //     }

            //     if (self.vendor_inv_type == "item") {
            //         if (self.rows[index].part == null || !self.rows[index].part.value) {
            //             self.rows[index].part_error_msg = "Part Required.";
            //             error = true;
            //         }
            //     }

            //     if (self.vendor_inv_type == "equipment") {
            //         if (self.rows[index].description == null || self.rows[index].description == "") {
            //             self.rows[index].desc_error_msg = "Description Required.";
            //             error = true;
            //         }
            //     }

            //     if (self.vendor_inv_type == "default") {
            //         if (self.rows[index].description == null || self.rows[index].description == "") {
            //             self.rows[index].desc_error_msg = "Description Required.";
            //             error = true;
            //         }

            //         if (self.rows[index].gl_account_id == null || !self.rows[index].gl_account_id.value) {
            //             self.rows[index].gl_account_error_msg = "GL Account Required.";
            //             error = true;
            //         }
            //         if (self.is_misc_po == 1) {
            //             if (self.rows[index].quantity == '' || self.rows[index].quantity == 0 ) {
            //                 self.rows[index].quantity_error_msg = "Quantity Required.";
            //                 error = true;
            //             }
            //             if (self.rows[index].unit_price == '' || self.rows[index].unit_price == 0 ) {
            //                 self.rows[index].unit_price_error_msg = "Unit Price Required.";
            //                 error = true;
            //             }
            //         }
            //     }

            //     if (self.vendor_inv_type == "sublet_invoice") {
            //         if (self.rows[index].description == null || self.rows[index].description == "") {
            //             self.rows[index].desc_error_msg = "Description Required.";
            //             error = true;
            //         }
            //         if ((self.rows[index].labor == "" || self.rows[index].labor == 0) && (self.rows[index].materials == "" || self.rows[index].materials == 0)) {
            //             if (self.rows[index].labor == "" || self.rows[index].labor == 0) {
            //                 self.rows[index].labor_error_msg = "Labor Amount Required.";
            //                 error = true;
            //             }
            //             if (self.rows[index].materials == "" || self.rows[index].materials == 0) {
            //                 self.rows[index].materials_error_msg = "Part Amount Required.";
            //                 error = true;
            //             }
            //         }
            //         if (self.woType == "multi unit") {
            //             if (self.rows[index].vehicle_id == null || !self.rows[index].vehicle_id.value) {
            //                 self.rows[index].vehicle_error_msg = "Unit No Required.";
            //                 error = true;
            //             }
            //         }
            //     }
            //     if (!error) {
            //         self.rows.push({
            //             bill_item_id:0,
            //             quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
            //             quantity_error_msg: "",
            //             unit_price: "",
            //             unit_price_error_msg: "",
            //             tax_percentage: 0,
            //             tax_percentage_error_msg: "",
            //             tax_amount: 0,
            //             tax_amount_error_msg: "",
            //             amount: 0,
            //             total: 0,
            //             description: "",
            //             desc_error_msg: "",
            //             part: null,
            //             part_error_msg: "",
            //             tax_id:"",
            //             gl_account_id:null,
            //             gl_account_error_msg:"",
            //             amount_error_msg:"",
            //             enableTaxSelect:true,
            //             vehicle_id:null,
            //             labor:0,
            //             labor_error_msg:"",
            //             materials:0,
            //             materials_error_msg:"",
            //             wo_type:self.woType,
            //             vehicle_error_msg:"",
            //             wo_item_id:""
            //         });
            //     }
            // }

            self.showTotalSummary = true;

        },
        removeElement: function (index) {
            var self = this;
            if (self.rows.length > 1) {
                if (self.rows[index].bill_item_id == 0) {
                    self.rows.splice(index, 1);
                    self.calculateTaxSubTotal();

                } else {
                    var idArr = [];
                    if (self.vendor_inv_type == "sublet_invoice") {
                        if (self.woType == "multi unit") {
                            if (self.rows[index].labor_item_id != undefined) {
                                if (self.rows[index].labor_item_id != null && self.rows[index].labor_item_id != "") {
                                    idArr.push(self.rows[index].labor_item_id);
                                }
                            }
                            if (self.rows[index].part_item_id != undefined) {
                                if (self.rows[index].part_item_id != null && self.rows[index].part_item_id != "") {
                                    idArr.push(self.rows[index].part_item_id);
                                }
                            }
                        }else{
                            idArr.push(self.rows[index].bill_item_id);
                        }
                    }else{
                        idArr.push(self.rows[index].bill_item_id);
                    }
                    if (confirm('Are you sure that you want to delete this Vendor Invoice Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/bill-item/delete",
                            type: "POST",
                            data: {
                                'id': idArr,
                                'type':self.vendor_inv_type
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    if (data.content == "wo_item") {
                                        self.$swal('',data.message,'info');
                                        return;
                                    }else{
                                        self.rows.splice(index, 1);
                                        self.calculateTaxSubTotal();
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-item-delete');
                            },
                        });
                    }
                }
            }

            self.showTotalSummary = true;

        },
        addLine: function () {

            var self = this;
            if ( self.chrows.length == 0 ) {
                var index = 0;

            } else {

                var index = self.chrows.length - 1;
                self.chrows[index].quantity_error_msg = "";
                self.chrows[index].unit_price_error_msg = "";
                self.chrows[index].charge_type_error_msg = "";
                self.chrows[index].amount_error_msg = "";
            }
                // if (self.chrows[index].charge_id != null && self.chrows[index].charge_id.value && self.chrows[index].quantity &&
                //     self.chrows[index].unit_price) {

                    self.chrows.push({
                        bill_item_id: 0,
                        charge_id: null,
                        charge_type_error_msg: "",
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        vehicle_id:null
                    });

                // } else {
                //     if (self.chrows[index].quantity == null || !self.chrows[index].quantity) {
                //         self.chrows[index].quantity_error_msg = "Quantity Required.";
                //     }
                //     if (self.chrows[index].unit_price == null || !self.chrows[index].unit_price) {
                //         self.chrows[index].unit_price_error_msg = "Unit Price Required.";
                //     }
                //     if (self.chrows[index].charge_id == null || !self.chrows[index].charge_id.value) {
                //         self.chrows[index].charge_type_error_msg = "Charge Type Required.";
                //     }
                // }

            if ( self.chrows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = true;
            }
        },
        removeChargeElement: function (index) {
            var self = this;
            //if (self.chrows.length > 1) {
                if (self.chrows[index].bill_item_id == 0) {
                    self.chrows.splice(index, 1);
                    self.calculateChargeAmount('',0);
                    self.calculateTaxSubTotal();
                } else {
                    var idArr = [];
                    idArr.push(self.chrows[index].bill_item_id);
                    if (confirm('Are you sure that you want to delete this Charges Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/bill-item/delete",
                            type: "POST",
                            data: {
                                'id': idArr,
                                'type':""
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.chrows.splice(index, 1);
                                    self.calculateChargeAmount('',0);
                                    self.calculateTaxSubTotal();
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-po-create-delete-item')
                            },
                        });
                    }
                }
            //}

            //Added line item back if no item is displayed..
            setTimeout(function () {
                if ( self.chrows.length == 0 ) {
                    self.addLine();
                }
            }, 1000);

            if (self.chrows.length > 1) {
                self.showTotalSummary = true;
            }else{
                self.showTotalSummary = true;
            }
        },
        calculateChargeAmount:function(evt,index){

            var self = this;

            var amount = 0;
            var totalAmount = 0
            var charges = 0;
            var adminFee = 0;

            for (var j = 0; j < self.rows.length; j++) {

                if ( self.vendor_inv_type == 'sublet_invoice') {
                    var itemTotal = 0;
                    if (self.rows[j].labor != "" && self.rows[j].labor != "-" && self.rows[j].labor != ".") {
                        itemTotal += self.removeFormat(self.rows[j].labor);
                    }
                    if (self.rows[j].materials != "" && self.rows[j].materials != "-" && self.rows[j].materials != ".") {
                        itemTotal += self.removeFormat(self.rows[j].materials);
                    }
                    self.rows[j].amount = itemTotal;
                    totalAmount += parseFloat(self.rows[j].amount);

                } else {
                    totalAmount += self.removeFormat(self.rows[j].amount);
                }

            }

            for (var k = 0; k < self.chrows.length; k++) {

                if (self.chrows[k].quantity != null && self.chrows[k].quantity != "" && self.chrows[k].quantity != "-") {
                    // if (self.vendor_inv_type == 'sublet_invoice') {
                    //     // if (self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                    //     if ( self.chrows[k].unit_price != null && self.chrows[k].unit_price != "" && self.chrows[k].unit_price != "-" ) {
                    //         self.chrows[k].amount = self.removeFormat(self.chrows[k].quantity) * self.removeFormat(self.chrows[k].unit_price);
                    //         charges += self.removeFormat(self.chrows[k].amount);
                    //     }
                    // } else {

                        if ( self.chrows[k].unit_price != null && self.chrows[k].unit_price != "" && self.chrows[k].unit_price != "-" ) {
                            self.chrows[k].amount = self.removeFormat(self.chrows[k].quantity) * self.removeFormat(self.chrows[k].unit_price);
                            charges += self.removeFormat(self.chrows[k].amount);
                        }
                    //}

                } else {
                    self.chrows[k].amount = 0;
                }
            }

            self.admin_charge = parseFloat(adminFee).toFixed(2);
            var sub_total = totalAmount + charges;
            self.sub_total = parseFloat(sub_total).toFixed(2);
            self.showTotalSummary = true;
            if ( self.vendor_inv_type == 'sublet_invoice') {
                self.receipt_amount = charges + totalAmount;
            }

        },
        calculateTaxSubTotal() {
            var self = this;
            var amount = 0;
            var taxAmount = 0

            for (var i = 0; i < self.rows.length; i++) {

                if( String(self.rows[i].quantity).includes(':')){

                    var quant = self.rows[i].quantity.split(':');
                    self.rows[i].quantity = quant[0];
                }

                //Default Vendor Invoice as per new change
                if (self.vendor_inv_type == "default" && self.is_misc_po == 0) {
                    self.rows[i].quantity = 1;
                    if (self.rows[i].amount != "" && self.rows[i].amount != "-") {
                        // self.rows[i].amount = parseFloat(self.rows[i].amount);
                        self.rows[i].unit_price = self.rows[i].amount;
                        self.rows[i].total = self.rows[i].amount;
                        if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                            self.rows[i].tax_amount =  parseFloat(( self.removeFormat(self.rows[i].amount) * self.rows[i].tax_id.percentage ) / 100);
                        }else{
                            self.rows[i].tax_amount = 0;
                        }
                        self.rows[i].total = self.removeFormat(self.rows[i].amount) + self.removeFormat(self.rows[i].tax_amount);
                        amount += self.removeFormat(self.rows[i].amount);
                        // self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                        taxAmount += self.removeFormat(self.rows[i].tax_amount);
                    }
                }else if (self.vendor_inv_type == "sublet_invoice") {
                    var itemTotal = 0;
                    if (self.rows[i].labor != "" && self.rows[i].labor != "-") {
                        itemTotal += self.removeFormat(self.rows[i].labor);
                    }
                    if (self.rows[i].materials != "" && self.rows[i].materials != "-") {
                        itemTotal += self.removeFormat(self.rows[i].materials);
                    }
                    self.rows[i].amount = itemTotal;
                    amount += parseFloat(itemTotal);
                }else{
                    console.log("MISC PO HERE");
                    if(self.rows[i].quantity == "-"){
                        self.rows[i].amount = parseFloat(0);
                        continue;
                    }
                    if ((self.rows[i].quantity > 0 || self.rows[i].quantity < 0) || self.rows[i].unit_price != '' ) {

                        if (self.rows[i].unit_price != '') {
                            if (String(self.rows[i].unit_price).includes(',')) {
                                self.rows[i].amount = self.rows[i].quantity * parseFloat(self.removeFormat(self.rows[i].unit_price));
                            }else{
                                self.rows[i].amount = self.rows[i].quantity * parseFloat(self.rows[i].unit_price);
                            }
                        }else{
                            self.rows[i].amount = 0;
                        }
                        // self.rows[i].amount=self.rows[i].quantity * self.rows[i].unit_price;
                        self.rows[i].amount = parseFloat(self.rows[i].amount);
                        // self.rows[i].amount = self.rows[i].amount.toFixed(2);
                        if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                            self.rows[i].tax_amount =  parseFloat(( self.removeFormat(self.rows[i].amount) * self.rows[i].tax_id.percentage ) / 100);
                        }else{
                            self.rows[i].tax_amount = 0;
                        }
                        self.rows[i].total = self.rows[i].amount;
                        self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                        amount += parseFloat(self.rows[i].amount);
                        self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                        taxAmount += parseFloat(self.rows[i].tax_amount);
                        var formatAmount = self.rows[i].amount.toFixed(2);
                        self.rows[i].amount = self.amountFormat(formatAmount);

                    } else {

                        if ( self.rows[i].amount != "" ) {
                            // self.rows[i].amount = parseFloat(self.rows[i].amount);
                            self.rows[i].total = self.rows[i].amount;
                            if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                                self.rows[i].tax_amount =  parseFloat(( self.rows[i].amount * self.rows[i].tax_id.percentage ) / 100);
                            }else{
                                self.rows[i].tax_amount = 0;
                            }
                            self.rows[i].total = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                            amount += self.removeFormat(self.rows[i].amount);
                            // self.rows[i].amount = parseFloat(self.rows[i].amount) + parseFloat(self.rows[i].tax_amount);
                            taxAmount += parseFloat(self.rows[i].tax_amount);
                        }
                    }
                }

            }

            self.pre_subtotal = self.sub_total;

            var charges = 0;
            for (var k = 0; k < self.chrows.length; k++) {

                charges += self.removeFormat(self.chrows[k].amount);

            }
            // self.sub_total += charges;
            var sub_total = amount + charges;
            self.sub_total = sub_total.toFixed(2);

        },
        calculateDiscount:function(evt,index){
            var self = this;

            var total = self.sub_total;

            var amount = 0;
            var totalAmount = 0
            var disTotal = 0;

            for (var j = 0; j < self.rows.length; j++) {

                totalAmount += parseFloat(self.rows[j].amount);

            }

            for (var k = 0; k < self.disrows.length; k++) {

                disTotal += parseFloat(self.disrows[k].discount);

            }

            self.totalDiscount = disTotal;
            amount = totalAmount - disTotal;

            if (amount > 0){

                self.total = parseFloat(amount);

                self.difference = amount - self.total;
                console.log("difference = ",self.difference);

            }
            self.showTotalSummary = true;

        },
        BillList() {
            var self = this;
            self.$router.push("/vendor-invoice/list");
        },
        CreateBill(flag) {
            var self = this;
            var error = false;
            // self.status_error_msg = "";
            self.bill_date_error_msg = "";
            self.due_date_error_msg = "";
            self.bill_error = '';
            // self.location_error_msg = "";
            self.vendor_error_msg = "";
            self.po_error_msg = "";
            self.fileerror_msg = '';
            self.matchingValuesError = [];
            self.assignee_error = "";
            self.post_period_error_msg = "";
            self.common_error_msg = "";
            self.paymentTypeError = "";

            if (!self.bill_date || self.bill_date == null || self.bill_date == "") {
                self.bill_date_error_msg = "Invoice Date Required.";
                error = true;
            }
            if (!self.bill_number || self.bill_number == null || self.bill_number == "") {
                self.bill_error = "Invoice Number Required.";
                error = true;
            } else if ( self.bill_number.length >= 20 ) {

                self.bill_error = "Invoice number should not be greater than 20 character.";
                error = true;
            }

            if (!self.vendor_id || self.vendor_id == null || self.vendor_id == "") {
                self.vendor_error_msg = "Vendor Required.";
                error = true;
            }
            if (!self.payment_type || self.payment_type == null || self.payment_type == "") {
                self.paymentTypeError = "Payment Type Required.";
                error = true;
            }

            if (self.poInvoiceFromWO == undefined) {
                //if vendor and assignee are same
                if (self.vendor_id != null && self.vendor_id != "") {
                    if (self.assignee != null && self.assignee != "") {
                        if (self.vendor_id.value == self.assignee.value) {
                            self.assignee_error = "Vendor and Assignee cannot be same.";
                            error = true;
                        }
                    }
                }
            }

            if ( self.bill_date != null && self.due_date != null && self.bill_date != "" && self.due_date != "" ) {
                var invoiceDate = Date.parse(self.bill_date);
                var dueDate = Date.parse(self.due_date);

                if( dueDate <= invoiceDate ) {
                    self.due_date_error_msg = "Due Date should be greater than Invoice Date.";
                    error = true;
                }
            }


            //file upload validation for Sublet Invoice
            var validateCreate = 0;
            var validateUpdate = 0;
            var validateRequired = 1;

            if (self.poInvoiceFromWO != undefined) {
                if (self.vendor_inv_type == 'sublet_invoice') {
                    if (self.poDataFromWO.billId > 0) {
                        validateUpdate = 1;
                    }else{
                        validateCreate = 1;
                    }
                }
            }else{
                if (self.$route.params.id > 0) {
                    // if (self.vendor_inv_type == 'sublet_invoice') {
                        validateUpdate = 1;
                    // }
                }else{
                    // if (self.vendor_inv_type == 'sublet_invoice') {
                        validateCreate = 1;
                    // }
                }
            }
            if (self.vendor_inv_type == "sublet_invoice") {
                if (self.vendor_id != null) {
                    if (self.vendor_id.code != undefined && self.vendor_id.code != null && self.vendor_id.code != "") {
                        // if (self.vendorInvDocOptionalArr.includes(self.vendor_id.code)) {
                        //     validateRequired = 0;
                        // }
                        if ( self.vendor_id.required_attachment == 0 ) {
                            validateRequired = 0;
                        }
                    }
                }
            }

            if (validateCreate == 1 && validateRequired == 1) {
                /*if (!self.filesArr.length ){
                    self.fileerror_msg = 'File Required';
                    error = true;
                }*/
                if (!self.docArr.length ){
                    self.fileerror_msg = 'File Required';
                    error = true;
                }
            }

            if (validateUpdate == 1 && validateRequired == 1) {

                if (!self.dropZonePreviewFiles.length && !self.docArr.length ){
                    self.fileerror_msg = 'File Required';
                    error = true;
                }
            }
            if (self.docArr.length > 0 && validateRequired == 1) {
                if (self.validateDocs.length > 0) {
                    for (var i = 0;i < self.validateDocs.length;i++) {
                        let fileObj = self.validateDocs[i];

                        if (fileObj.extension != undefined) {
                          console.log('FileObj=>',fileObj);
                          console.log('file extension =>',fileObj.extension);
                            if (fileObj.extension == "jpeg" || fileObj.extension == "png" || fileObj.extension == "jpg" || fileObj.extension == "pdf" || fileObj.extension == "doc" || fileObj.extension == "docx" || fileObj.extension == "msword" || fileObj.extension == "vnd.openxmlformats-officedocument.wordprocessingml.document") {

                            }else{
                                self.fileerror_msg = "Only Images or PDF or Doc Files Are Allowed (.jpg / .jpeg / .png / .pdf / .doc / .docx).";
                                error = true;
                            }
                        }

                        if (fileObj.size != undefined) {
                            if(fileObj.size > 10000000){
                                self.fileerror_msg = "File size should not be greater than 10 MB.";
                                error = true;
                            }
                        }
                    }
                }
            }

            // if (!self.postPeriod || self.postPeriod == "" || self.PostPeriod == "__/____") {
            //     self.post_period_error_msg = "Period Required.";
            //     error = true;
            // }else{
                if (self.PostPeriod != "" && self.PostPeriod != "__/____") {
                    var periodRE = /^(0[123456789]|10|11|12)([/])([1-2][0-9][0-9][0-9])$/;
                    if(self.postPeriod && !self.postPeriod.match(periodRE)){
                        self.post_period_error_msg = "Period must be in proper format";
                        error = true;
                    }else{
                        //remove validation as period can be back dated.
                        //compare period and invoice date period
                        // if (self.bill_date != null && self.bill_date != "") {
                        //     var billPeriod = moment(self.bill_date).format('MM/YYYY');
                        //     var billPrdSplt = billPeriod.split('/');
                        //     if (billPrdSplt[0] && billPrdSplt[0] != "") {
                        //         if (billPrdSplt[1] && billPrdSplt[1] != "") {
                        //             var postPrdSplt = self.postPeriod.split('/');
                        //             if (postPrdSplt[0] && postPrdSplt[0] != "") {
                        //                 if (postPrdSplt[1] && postPrdSplt[1] != "") {
                        //                     if (postPrdSplt[1] < billPrdSplt[1]) {
                        //                         self.post_period_error_msg = "Period cannot be less than Invoice Date";
                        //                         error = true;
                        //                     }else{
                        //                         if (postPrdSplt[1] < billPrdSplt[1] || postPrdSplt[1] == billPrdSplt[1]) {
                        //                             if (postPrdSplt[0] < billPrdSplt[0]) {
                        //                                 self.post_period_error_msg = "Period cannot be less than Invoice Date";
                        //                                 error = true;
                        //                             }
                        //                         }
                        //                     }
                        //                 }
                        //             }
                        //         }
                        //     }
                        // }
                    }
                }
            // }


            var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
            var checkPartFound = 0;

            //charge selection optional for all vendor invoices
            if (self.chrows.length > 0){
                //if (self.chrows[0].charge_id != undefined && self.chrows[0].charge_id != null ){
                    // if (self.chrows[0].charge_id.value){
                        for(var j = 0;j < self.chrows.length; j++){
                            self.chrows[j].quantity_error_msg = "";
                            self.chrows[j].unit_price_error_msg = "";
                            self.chrows[j].charge_type_error_msg = "";
                            var blank = 0,filled = 0;

                            if (self.chrows[j].quantity == null || !self.chrows[j].quantity || self.chrows[j].quantity == 0) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                            if (self.chrows[j].unit_price == null || !self.chrows[j].unit_price || self.chrows[j].unit_price == 0) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                            if (self.chrows[j].charge_id == null || !self.chrows[j].charge_id.value) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if ( filled == blank ) {

                                error = true;
                                if (self.chrows[j].quantity == null || !self.chrows[j].quantity || self.chrows[j].quantity == 0) {
                                    self.chrows[j].quantity_error_msg = "Quantity Required.";
                                }
                                if (self.chrows[j].unit_price == null || !self.chrows[j].unit_price || self.chrows[j].unit_price == 0) {
                                    self.chrows[j].unit_price_error_msg = "Unit Price Required.";
                                }
                                if (self.chrows[j].charge_id == null || !self.chrows[j].charge_id.value) {
                                    self.chrows[j].charge_type_error_msg = "Charge Type Required.";
                                }
                            }
                        }
                    // }
                // }else{
                //     for(var j = 0;j < self.chrows.length; j++){
                //         self.chrows[j].quantity_error_msg = "";
                //         self.chrows[j].unit_price_error_msg = "";
                //         self.chrows[j].charge_type_error_msg = "";
                //     }
                // }
            }

            if (self.vendor_inv_type == 'item') {
                //check whether Part Added Or Not and Tax Amount is added
                if (checkPartFound == 0 && self.total_tax > 0) {
                    if (confirm('Part Amount Not Added. Do you still want to add Tax Amount?')) {

                    }else{
                        return;
                    }
                }
            }
            //Sublet Invoice Type
            console.log("before line error "+ error)
            if ( self.vendor_inv_type != "sublet_invoice" ) {

                for (var i = 0; i < self.rows.length; i++) {

                    self.rows[i].desc_error_msg = "";
                    self.rows[i].unit_price_error_msg = "";
                    self.rows[i].quantity_error_msg = "";
                    self.rows[i].part_error_msg = "";
                    self.rows[i].gl_account_error_msg = "";
                    self.rows[i].amount_error_msg = "";
                    var blank = 0,filled = 0;

                    if(self.vendor_inv_type == 'item') {

                        if (self.rows[i].part == null || !self.rows[i].part.value) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }
                    } else if (self.vendor_inv_type == 'equipment') {

                        if  ( self.order_id == '' ) {
                            if (self.rows[i].description == null || self.rows[i].description == "" ) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                        }

                        if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }
                    } else if (self.vendor_inv_type == 'default'){

                        // if (self.rows[i].description == null || self.rows[i].description == "" || self.rows[i].description.trim() == "") {
                        //     blank = 1;
                        // } else {
                        //     filled = 1;
                        // }
                        if (self.rows[i].gl_account_id == null || !self.rows[i].gl_account_id.value) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.rows[i].amount == null || self.rows[i].amount == "" ||  self.rows[i].amount == 0.00 ) {
                            blank = 1;
                        } else {
                            filled = 1;
                        }

                        if (self.is_misc_po == 1) {
                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                        }
                    }
                    if ( filled == blank ) {

                        error = true;
                        if(self.vendor_inv_type == 'item') {

                            if (self.rows[i].part == null || !self.rows[i].part.value) {
                                self.rows[i].part_error_msg = "Part Required.";
                            }

                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                self.rows[i].unit_price_error_msg = "Unit Price Required.";
                             }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                self.rows[i].quantity_error_msg = "Quantity Required.";
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                                self.rows[i].amount_error_msg = "Amount Required.";
                            }

                        } else if (self.vendor_inv_type == 'equipment') {

                            if  ( self.order_id == '' ) {
                                if (self.rows[i].description == null || self.rows[i].description == "" ) {
                                    self.rows[i].desc_error_msg = "Description Required.";
                                }
                            }

                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                self.rows[i].unit_price_error_msg = "Unit Price Required.";
                            }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                self.rows[i].quantity_error_msg = "Quantity Required.";
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                                self.rows[i].amount_error_msg = "Amount Required.";
                            }

                        } else if (self.vendor_inv_type == 'default'){

                            // if (self.rows[i].description == null || self.rows[i].description == "" || self.rows[i].description.trim() == "") {
                            //     self.rows[i].desc_error_msg = "Description Required.";
                            // }
                            if (self.rows[i].gl_account_id == null || !self.rows[i].gl_account_id.value) {
                                self.rows[i].gl_account_error_msg = "GL Account Required.";
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ||  self.rows[i].amount == 0.00 ) {
                                self.rows[i].amount_error_msg = "Amount Required.";
                            }

                            if (self.is_misc_po == 1) {
                                if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                    self.rows[i].unit_price_error_msg = "Unit Price Required.";
                                }

                                if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                    self.rows[i].quantity_error_msg = "Quantity Required.";
                                }
                            }
                        }
                    }

                    if (self.vendor_inv_type == 'item') {
                        if (self.rows[i].part != null && self.rows[i].part.value) {
                            checkPartFound = 1;
                        }
                    }
                }
            }

            //Sublet Invoice Type
            if (self.vendor_inv_type == 'sublet_invoice') {
                var laborValFound = 0;
                var laborAmt = 0;
                var partValFound = 0;
                var partAmt = 0;
                var descVehicleArr = [];

                if(self.location_id == null || !self.location_id.value){
                    self.location_error_msg = "Location Required";
                    error = true;
                }

                for(var i = 0;i < self.rows.length;i++) {
                    self.rows[i].desc_error_msg = "";
                    self.rows[i].labor_error_msg = "";
                    self.rows[i].materials_error_msg = "";
                    self.rows[i].vehicle_error_msg = "";
                    if (self.rows[i].description == null || self.rows[i].description == "") {
                        self.rows[i].desc_error_msg = "Description Required.";
                        error = true;
                    }
                    if ((self.rows[i].labor == "" || self.rows[i].labor == 0) && (self.rows[i].materials == "" || self.rows[i].materials == 0)) {
                        if (self.rows[i].labor == "" || self.rows[i].labor == 0) {
                            self.rows[i].labor_error_msg = "Labor Amount Required.";
                            error = true;
                        }
                        if (self.rows[i].materials == "" || self.rows[i].materials == 0) {
                            self.rows[i].materials_error_msg = "Part Amount Required.";
                            error = true;
                        }
                    }
                    if (self.woType == "multi unit") {
                        if (self.rows[i].vehicle_id == null || !self.rows[i].vehicle_id.value) {
                            self.rows[i].vehicle_error_msg = "Unit No Required.";
                            error = true;
                        }
                        if (self.rows[i].description != null && self.rows[i].description != ""
                            && self.rows[i].vehicle_id != null && self.rows[i].vehicle_id.value) {
                            var descVehicle = self.rows[i].description+""+self.rows[i].vehicle_id.value;
                            if (descVehicleArr.includes(descVehicle)) {
                                self.rows[i].desc_error_msg = "Description and Unit No. Already Added.";
                                error = true;
                            }else{
                                descVehicleArr.push(descVehicle);
                            }
                        }
                    }
                    if (self.rows[i].labor != "" && self.rows[i].labor != 0) {
                        laborAmt += Number(self.rows[i].labor);
                    }
                    if (self.rows[i].materials != "" && self.rows[i].materials != 0) {
                        partAmt += Number(self.rows[i].materials);
                        partValFound = 1;
                    }
                }
                //check whether Sublet Part Added Or Not and Tax Amount is added
                if (partValFound == 0 && self.total_tax > 0) {
                    if (confirm('Sublet Part Amount Not Added. Do you still want to add Tax Amount?')) {

                    }else{
                        return;
                    }
                }
            }

            console.log("after error check "+error)
            if ( self.bill_date != "" && self.due_date != "" && self.bill_number != "" ) {

                if ( self.valuesFound ) {

                    if ( self.pdfArr.invDate != undefined && self.pdfArr.invDate != null && self.pdfArr.invDate != "") {

                        if ( $("#bill_date").val() != self.pdfArr.invDate ) {
                            self.matchingValuesError.push("Invoice Date");
                        }

                    }

                    if ( self.pdfArr.invDueDate != undefined && self.pdfArr.invDueDate != null && self.pdfArr.invDueDate != "") {

                        if ( $("#due_date").val() != self.pdfArr.invDueDate ) {
                            self.matchingValuesError.push("Due Date");
                        }

                    }

                    if ( self.pdfArr.invNo != undefined && self.pdfArr.invNo != null && self.pdfArr.invNo != "") {

                        if ( self.bill_number != self.pdfArr.invNo ) {
                            self.matchingValuesError.push("Invoice #");
                        }
                    }

                    if ( self.pdfArr.invAmount != undefined && self.pdfArr.invAmount != null && self.pdfArr.invAmount != "") {

                        if ( self.total != self.pdfArr.invAmount ) {
                            self.matchingValuesError.push("Total");
                        }
                    }

                }
            }
            console.log("after bil date and number check "+error)

            //if from vendor invoice form
            if (self.poInvoiceFromWO == undefined) {
                if ( self.valuesFound && self.matchingValuesError.length > 0 ) {
                    $("#error-message-modal").modal("show");
                    error = true;
                }
            }


            console.log("ERROR ==", error);
            if (!error) {

                if ( self.vendor_inv_type != "sublet_invoice" ) {

                    for (var i = 0; i < self.rows.length; i++) {

                        var blank = 0,filled = 0;

                        if(self.vendor_inv_type == 'item') {

                            if (self.rows[i].part == null || !self.rows[i].part.value) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                        } else if (self.vendor_inv_type == 'equipment') {

                            if  ( self.order_id == '' ) {
                                if (self.rows[i].description == null || self.rows[i].description == "" ) {
                                    blank = 1;
                                } else {
                                    filled = 1;
                                }
                            }

                            if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }
                        } else if (self.vendor_inv_type == 'default'){

                            // if (self.rows[i].description == null || self.rows[i].description == "" || self.rows[i].description.trim() == "") {
                            //     blank = 1;
                            // } else {
                            //     filled = 1;
                            // }
                            if (self.rows[i].gl_account_id == null || !self.rows[i].gl_account_id.value) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.rows[i].amount == null || self.rows[i].amount == "" ||  self.rows[i].amount == 0.00 ) {
                                blank = 1;
                            } else {
                                filled = 1;
                            }

                            if (self.is_misc_po == 1) {
                                if (self.rows[i].unit_price == null || self.rows[i].unit_price == 0 || !self.rows[i].unit_price) {
                                    blank = 1;
                                } else {
                                    filled = 1;
                                }

                                if (self.rows[i].quantity == null || !self.rows[i].quantity || self.rows[i].quantity == 0) {
                                    blank = 1;
                                } else {
                                    filled = 1;
                                }
                            }

                        }

                        //remove line if no data input
                        if ( blank == 1 ) {
                            self.removeElement(i);
                            i = 0;
                        }
                    }
                }

                var path = window.location.pathname;
                var segments = path.split("/");
                var chargeIdsArr = [];
                var typesArr = [];
                var amountArr = [];
                var taxPercentageArr = [];
                var totalChargeArr = [];


                const fields = new FormData();

                fields.append('items',JSON.stringify($("#BillForm").serializeArray()));
                // alert(JSON.stringify(fields));

                if (self.vendor_id == null) {
                    fields.append(
                        "vendor_id",
                        ""
                    );
                } else {
                    fields.append(
                        "vendor_id",
                        self.vendor_id.value
                    );
                }

                if (self.assignee != null && self.assignee != "") {
                    fields.append(
                        "assignee",
                        self.assignee.value
                    );
                } else {
                    fields.append(
                        "assignee",
                        ""
                    );
                }
                if ( self.total > 0 || self.total < 0){

                    fields.append(
                        "billItems",
                        JSON.stringify(self.rows)
                    );
                }else{
                    fields.append(
                        "billItems",
                         []
                    );
                }

                if ( self.disrows && self.disrows.length > 0){

                    fields.append(
                        "discountItems",
                        JSON.stringify(self.disrows)
                    );
                }else{
                    fields.append(
                        "discountItems",
                         []
                    );
                }

                if(self.chrows.length > 0) {

                  //handle for case of sublet invoice not added
                  fields.append(
                    "chargesItem",
                    JSON.stringify(self.chrows)
                 );

                } else {
                  fields.append(
                          "chargesItem",
                          []
                      );
                }


                fields.append(
                    "voucher_number",
                    self.voucher
                );


                fields.append(
                    "amount",
                    self.total
                );

                fields.append(
                    "docArr",
                    JSON.stringify(self.docArr)
                );
                if(self.payment_type != null) {
                    fields.append("payment_type", self.payment_type.value);
                } else {
                    fields.append("payment_type", "");
                }

                if (self.poInvoiceFromWO != undefined) {
                    if (self.poDataFromWO.billId != undefined) {
                        if (self.poDataFromWO.billId != null) {
                            //Update Invoice From Work Order View
                            if (self.poDataFromWO.billId > 0) {
                                fields.append(
                                    "id",
                                    self.bill_id
                                );
                            }
                        }
                    }else{
                        //Generate Invoice From Work Order View
                        fields.append(
                            "id",
                            ""
                        );
                    }
                }else{
                    fields.append(
                        "id",
                        segments[3]
                    );
                    //invoice created from Vendor Invoice Form default status verified
                    fields.append(
                        "default_status",
                        self.default_status
                    );
                }

                fields.append(
                    "vendor_inv_type",
                    self.vendor_inv_type
                );
                if (self.updateVendor){
                    fields.append(
                        "update_vendor",
                        'yes'
                    );
                }else{
                    fields.append(
                        "update_vendor",
                        'no'
                    );
                }


                if (self.po == null || self.po == "") {
                    fields.append("po", "");
                } else{
                    fields.append("po", self.po.value);
                }
                if (self.location_id == null || self.location_id == "") {
                    fields.append("location_id", "");
                } else{
                    fields.append("location_id", self.location_id.value);
                }

                console.log("ORD ID =", self.order_id);


                if(self.order_id != "" && self.order_id != "0") {
                    fields.append(
                        "approve_order_id",
                        self.order_id
                    );
                }

                fields.append(
                    "admin_charge",
                    self.admin_charge
                );
                fields.append("wo_type",self.woType);
                if(self.woType == "default") {
                    fields.append("wo_vehicle_id",self.vehicleId);
                    fields.append("wo_item_id", self.woItemId);
                }else{
                    fields.append("wo_vehicle_id", "");
                    fields.append("wo_item_id", "");
                }
                fields.append(
                    "receipt_amount",
                    self.receipt_amount
                );
                fields.append(
                    "total_amount",
                    self.removeFormat(self.total)
                );

                // console.log(fields);
                // if (self.po.value && self.po.amount && self.po.amount != self.total && (!segments[3] || self.poInvoiceFromWO != undefined)){
                if (self.po.value && self.po.amount && self.po.amount != self.total && (segments[3] || self.poInvoiceFromWO != undefined || self.poInvoiceFromWO == undefined)){
                    if (confirm('PO and Invoice amount are different')) {
                        self.createBillAPI(fields,flag);
                    }else{
                        return;
                    }
                }else{
                    if (self.poInvoiceFromWO != undefined) {
                        if (self.vendor_inv_type == 'sublet_invoice') {
                            if (self.poDataFromWO.billId == 0) {
                                if (self.woType == 'multi unit') {//Prompt User on create multi unit vendor invoice and close work order
                                    if (confirm('All work order line items will be closed')) {
                                        self.createBillAPI(fields,flag);
                                    }else{
                                        return;
                                    }
                                }else{
                                    self.createBillAPI(fields,flag);
                                }
                            }else{
                                self.createBillAPI(fields,flag);
                            }
                        }else{
                            self.createBillAPI(fields,flag);
                        }
                    }else{
                        self.createBillAPI(fields,flag);
                    }
                }

            }else{
                self.errorValidationFocus();
            }
        },
        createBillAPI:function(fields,flag){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.$parent.loading = true;

            if (segments[3]) {
                    $("#CreateBillBtn").val("Updating ...");
                    // $("#CreateBillBtn").prop("disabled", true);
                    // $("#CreateBillBtn").prop("disabled", true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueBillBtn").val("Saving ...");
                        $("#CreateBillBtn").prop("disabled", true);
                        $("#createAndContinueBillBtn").prop("disabled", true);
                        $("#cancelBillBtn").prop("disabled", true);

                    } else {

                        $("#CreateBillBtn").val("Saving ...");
                        $("#CreateBillBtn").prop("disabled", true);
                        $("#createAndContinueBillBtn").prop("disabled", true);
                        $("#cancelBillBtn").prop("disabled", true);
                    }
                }

            $.ajax({
                url: process.env.ROOT_API + "/bill/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;

                    if (segments[3]) {
                        $("#CreateBillBtn").val("Update");
                        $("#CreateBillBtn").prop("disabled", false);
                        $("#cancelBillBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueBillBtn").val("Save and Continue");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        } else {

                            $("#CreateBillBtn").val("Save");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        }
                    }
                    if (data.status == "success") {

                        self.showCharges = false;

                        if (flag == "Save and Continue") {
                            //$("#BillForm").trigger("reset");
                            self.bill_number = "";
                            //self.bill_date = "";
                            //self.due_date = "";
                            self.order_id = "";
                            self.redirectFrom = "";
                            self.notes = "";
                            self.reference = "";
                            // self.vendor_inv_type = "default";
                            // self.vendor_invoice_type = {text:'Default' , value:'default'};
                            self.assignee = "";
                            self.postPeriod = "";
                            /*self.status = {
                                value: "open",
                                text: "Open"
                            };*/
                            //self.getPurchaseOrderNo();
                            self.rows = [];
                            self.rows.push({
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            },
                            {
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            },{
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            },{
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            },{
                                bill_item_id:0,
                                quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                vehicle_id:null,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            });

                            self.chrows = [];
                            self.chrows.push({
                                bill_item_id: 0,
                                charge_id: null,
                                charge_type_error_msg: "",
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                vehicle_id:null
                            },{
                                bill_item_id: 0,
                                charge_id: null,
                                charge_type_error_msg: "",
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                vehicle_id:null
                            },{
                                bill_item_id: 0,
                                charge_id: null,
                                charge_type_error_msg: "",
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                vehicle_id:null
                            });
                            if (self.vendor_inv_type == "default") {
                                self.chrows = [];
                            }

                            self.disrows = [];

                            /*self.disrows.push({
                                discount_id:0,
                                discount: 0,
                                description: "",
                                description_error_msg: "",
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                discount_error_msg:"",
                            });*/

                            self.po = '';
                            self.filesArr = [];
                            self.location_id = '';

                            self.sub_total = 0;
                            self.sub_total.toFixed(2);

                            self.totalDiscount = 0;

                            self.total_tax = 0;
                            self.total_tax.toFixed(2);

                            self.total = 0;
                            self.receipt_amount = 0;
                            self.difference = self.receipt_amount - self.total;
                            console.log("difference = ",self.difference);
                            self.showTotalSummary = true;

                            //var todayDate = self.getTodayDate();
                            //self.bill_date = moment(todayDate,"MM/DD/YYYY");
                            self.isPORequired = false;
                            self.poRequiredClass = '';
                            self.removeAllFiles();
                            self.docArr = [];
                            self.validateDocs = [];

                        } else {
                            //from work order view page
                            if (self.poInvoiceFromWO != undefined) {
                                self.$parent.hideInvoicePOForm();
                                self.$parent.loadWorkOrderDetail();
                            }else{
                                if(self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'poreceipttab' && self.po != null && self.po.value){
                                    self.$router.push('/vendor-purchase-order/view/'+self.po.value);
                                }else{
                                    //to solve bug # 7063
                                    // if (self.redirectFrom != undefined && self.redirectFrom != '' && (self.redirectFrom == 'receiptcreate' || self.redirectFrom == 'receiptview') && self.receipt_id != null && self.receipt_id != "") {
                                    //     self.$router.push("/record-receipt/view/"+self.receipt_id);
                                    // }else{
                                        if(self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'approveorder'){
                                            self.$router.push("/order/list");
                                        }else{
                                            self.$router.push("/vendor-invoice/view/"+data.content.id);
                                        }
                                    // }
                                }
                            }

                        }

                    } else {
                        if(data.content == 'no_data'){
                            self.$swal({
                            title: 'This Vendor Invoice Not Available.',
                            type: 'info',
                            confirmButtonText: 'OK',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.BackBillList();
                            }
                        });
                        }else if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                                self.common_error_msg += data.content[i] + "\n";
                            }
                            // $("#errorMsg").html(err);
                            // $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                // $(".alert-warning").removeClass("show");
                                // $(".alert-warning").addClass("hide");
                                self.common_error_msg = "";
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    if (segments[3]) {
                        $("#CreatePurchaseOrderBtn").val("Update");
                        $("#CreatePurchaseOrderBtn").prop("disabled", false);
                        $("#cancelPurchaseOrderBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueBillBtn").val("Save and Continue");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        } else {

                            $("#CreateBillBtn").val("Save");
                            $("#CreateBillBtn").prop("disabled", false);
                            $("#createAndContinueBillBtn").prop("disabled", false);
                            $("#cancelBillBtn").prop("disabled", false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'vendor-invoice-create');
                }
            });
        },
        leaveFocusUnitPrice:function(evt,index,type) {
            var self = this;
            evt = (evt) ? evt : window.event;
            if(type == 'material'){
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].materials = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].materials = evt.target.value.replace(/\,/g,"");
                    self.rows[index].materials = self.amountFormat(self.rows[index].materials);
                }
            }else if(type == 'labor'){
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].labor = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].labor = evt.target.value.replace(/\,/g,"");
                    self.rows[index].labor = self.amountFormat(self.rows[index].labor);
                }
            }else
            if (type == "amount"){
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].amount = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].amount = evt.target.value.replace(/\,/g,"");
                    self.rows[index].amount = self.amountFormat(self.rows[index].amount);
                }
            }else
            if ( type == "item-price" ) {
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].unit_price = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].unit_price = evt.target.value.replace(/\,/g,"");
                    self.rows[index].unit_price = self.amountFormat(self.rows[index].unit_price);
                }
            }else{
                if(evt.target.value.indexOf(",") == -1) {
                    self.chrows[index].unit_price = self.amountFormat(evt.target.value);
                } else {
                    self.chrows[index].unit_price = evt.target.value.replace(/\,/g,"");
                    self.chrows[index].unit_price = self.amountFormat(self.chrows[index].unit_price);
                }
            }
        },
        enterUnitPrice:function(evt,index,type) {
            var self = this;
            evt = (evt) ? evt : window.event;
            if(type == 'material'){
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].materials = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].materials = evt.target.value.replace(/\,/g,"");
                    self.rows[index].materials = self.amountFormat(self.rows[index].materials);
                }
            }else if(type == 'labor'){
                if(evt.target.value.indexOf(",") == -1) {
                    self.rows[index].labor = self.amountFormat(evt.target.value);
                } else {
                    self.rows[index].labor = evt.target.value.replace(/\,/g,"");
                    self.rows[index].labor = self.amountFormat(self.rows[index].labor);
                }
            }else
            if (type == "amount"){
                self.rows[index].amount = evt.target.value.replace(/\,/g,"");
                self.rows[index].amount = evt.target.value;
            }else
            if (type == "item-price"){
                self.rows[index].unit_price = evt.target.value.replace(/\,/g,"");
                self.rows[index].unit_price = evt.target.value;
            }else{
                self.chrows[index].unit_price = evt.target.value.replace(/\,/g,"");
                self.chrows[index].unit_price = evt.target.value;
            }
        },
        onSearchPurchaseOrder(search, loading) {
            var self = this;
            self.po_error_msg = "";
            if ( self.vendor_id != null && self.vendor_id.value != "" ) {
                if (search.length > 0 ){
                    self.searchPo(search);
                }
            }else{
                self.po_error_msg = "Vendor Required.";
            }
        },
        //purchase order for customer with status open
        searchPo(searchValue) {

            var self = this;

            // self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/po/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {
                    // customer_id: custId,
                    search: searchValue,
                    flag: "vendor",
                    vendor:self.vendor_id.value
                },
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    if (data.status == "success") {
                        self.purchaseOrderArr = data.content;
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'search-vendor-po');
                }
            });
        },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        BackBillList() {
            var self = this;
            //hide form in work order view
            if(self.redirectFrom != undefined && self.redirectFrom != '' && (self.redirectFrom == 'poview' || self.redirectFrom == 'poreceipttab') && self.po != null && self.po.value){
                self.$router.push('/vendor-purchase-order/view/'+self.po.value);
            }else
            if (self.poInvoiceFromWO != undefined) {
                self.$parent.hideInvoicePOForm();
            }else{
                if (self.redirectFrom != undefined && self.redirectFrom != '' && (self.redirectFrom == 'receiptcreate' || self.redirectFrom == 'receiptview') && self.receipt_id != null && self.receipt_id != "") {
                    self.$router.push("/record-receipt/view/"+self.receipt_id);
                }else if (self.redirectFrom != undefined && self.redirectFrom != '' && self.redirectFrom == 'approveorder'){
                    self.$router.push("/order/list");
                }else{
                    self.$router.push({ name: 'BillList'});
                }
            }
        },
        deleteBillFile: function(key,file){

            var self = this;

            if (confirm('Are you sure that you want to remove file? ')) {

                if(self.bill_id != '' && self.bill_id != undefined){

                    self.$parent.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/remove-bill-file",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            bill_id:self.bill_id,
                            doc_path:file
                        },
                        success: function(data) {
                            self.$parent.loading = false;
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                self.filesArr.splice(key,1);
                                self.docArr.splice(key,1);
                                self.validateDocs.splice(key,1);
                                self.loadBillDetail(self.bill_id);
                                // $("#myModal").modal("hide");
                                // self.$refs.files.value = '';
                                // self.existFilesArr = [];
                                if (self.valuesFound) {
                                    self.valuesFound = false;
                                    self.matchingValuesError = [];
                                }
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.$parent.loading = false;
                            self.filesArr.splice(key,1);
                            self.docArr.splice(key,1);
                            self.validateDocs.splice(key,1);
                            self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-doc-remove');
                        }
                    });

                } else{

                    self.filesArr.splice(key,1);
                    self.$refs.files.value = '';


                }
            }

        },
        // amountFormat1(amount) {

        //     return amount.toLocaleString('en-US', {
        //         style: 'currency',
        //         currency: 'USD'
        //     });
        // },
        onVendorChange() {

            var self = this;
            self.vendor_error_msg = "";
            self.po_error_msg = "";
            self.due_date_error_msg = "";

            if (self.vendor_id != null && self.vendor_id != "" ) {

                //populate assignee
                if ( self.vendor_id.assigneeVal != "" ) {
                    self.assignee = {value:self.vendor_id.assigneeVal,text:self.vendor_id.assigneeText}
                }
                //populate payment
                if ( self.vendor_id.paymentname != "" ) {
                    self.payment_type = {value:self.vendor_id.paymentcode,text:self.vendor_id.paymentname}
                }
                //fetch gl accounts of vendor only if vendor is monthly payable
                if (self.vendor_id.monthly_payable != undefined && self.vendor_id.monthly_payable != null) {
                    if (self.vendor_id.monthly_payable == 1) {
                        self.fetchVendorGL();
                    }else{
                        self.vendorGLAccounts = [];
                    }
                }else{
                    self.vendorGLAccounts = [];
                }
                if ( self.vendor_id.term != null ) {

                    var date = '';
                    if ( self.vendor_id.term_period != null ) {
                        if(self.vendor_id.term_period == 'month'){
                            date = moment(self.bill_date, "MM/DD/YYYY")
                                    .add(self.vendor_id.term,'month') //replace 2 with number of days you want to add

                        }else{

                            date = moment(self.bill_date, "MM/DD/YYYY")
                                    .add(self.vendor_id.term,'days');
                        }
                        //populate due date on the basis of terms if due date is blank
                        if (self.due_date == "" || self.due_date == null) {
                            self.due_date = date;
                        }
                    }
                }

                // check if vendor invoice file required or not
                self.fileRequired = 'require';
                if ( self.vendor_id.required_attachment == 0 && self.vendor_invoice_type == 'sublet_invoice') {
                    self.fileRequired = ''
                }

                // self.vendor_inv_type = "default";
                // self.vendor_invoice_type = {text:'Default' , value:'default'};
                if ( self.vendor_invoice_type == 'sublet_invoice') {
                    self.updateVendor = true;
                }else{
                    if (self.po != '' && self.po != null && self.po.value){
                        self.$swal({
                            title: 'Do you want to update vendor in Purchase order?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                            showCloseButton: false,
                            showLoaderOnConfirm: true
                        }).then((result) => {
                            if (result.value) {
                                self.updateVendor = true;
                            } else {
                                self.po = '';
                                self.purchaseOrderArr = [];
                                self.updateVendor = false;
                            }
                        });
                    }
                }

                if ( self.vendor_id.po_required == 1 ) {
                    self.isPORequired = true;
                    self.poRequiredClass = 'required';
                }else{
                    self.isPORequired = false;
                    self.poRequiredClass = '';
                }
            } else {
                // self.due_date = "";
                self.po = '';
                self.purchaseOrderArr = [];
                self.isPORequired = false;
                self.poRequiredClass = '';
                self.vendorGLAccounts = [];
            }

        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 5) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
        hideMessageModal() {
            var self = this;
            self.matchingValuesError = [];
            $("#error-message-modal").modal("hide");
        },
        submitBill() {
            var self = this;
            $("#error-message-modal").modal("hide");
            self.valuesFound = false;
            self.matchingValuesError = [];
            self.CreateBill();
        },

        addDiscountRow: function () {

            var self = this;
            var index = self.disrows.length - 1;

            if ( self.rows.length == 1 ) {
                self.disrows[0].description_error_msg = "Please add invoice line item first";
                return;
            }
            self.disrows[index].description_error_msg = "";
            self.disrows[index].gl_account_error_msg = "";
            self.disrows[index].discount_error_msg = "";

            if ((self.disrows[index].description != null && self.disrows[index].description != "" && self.disrows[index].description.trim() != "") && ( self.disrows[index].discount != null && self.disrows[index].discount != "") && (self.disrows[index].gl_account_id != null && self.disrows[index].gl_account_id.value)) {
                self.disrows.push({
                    discount_id:0,
                    discount: 0,
                    description: "",
                    description_error_msg: "",
                    gl_account_id:null,
                    gl_account_error_msg:"",
                    discount_error_msg:"",
                });

            } else {

                if (self.disrows[index].description == null || self.disrows[index].description == "") {
                    self.disrows[index].description_error_msg = "Description is Required.";
                }
                if (self.disrows[index].gl_account_id == null || !self.disrows[index].gl_account_id.value) {
                    self.disrows[index].gl_account_error_msg = "GL Account is Required.";
                }
                if (self.disrows[index].discount == null || self.disrows[index].discount == "" ) {
                    self.disrows[index].discount_error_msg = "Amount Required.";
                }
            }
            if ( self.disrows.length > 1) {
                self.showTotalSummary = true;
            }
        },
        removeDiscountElement: function (index) {
            var self = this;
            if (self.disrows.length >= 1) {
                if (self.disrows[index].discount_id == 0) {
                    self.disrows.splice(index, 1);
                    self.calculateDiscount();

                } else {
                    if (confirm('Are you sure that you want to delete this Vendor Invoice Discount Item? ')) {
                        $.ajax({
                            url: process.env.ROOT_API + "/discount-item/delete",
                            type: "POST",
                            data: {
                                'id': self.disrows[index].discount_id
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                if (data.status == "success") {
                                    self.disrows.splice(index, 1);
                                    self.calculateDiscount();
                                }

                                if (self.disrows.length == 0) {
                                    self.disrows.push({
                                        discount_id:0,
                                        discount: 0,
                                        description: "",
                                        description_error_msg: "",
                                        gl_account_id:null,
                                        gl_account_error_msg:"",
                                        discount_error_msg:"",
                                    });
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-item-delete');
                            },
                        });
                    }
                }
            }
            if ( self.disrows.length > 1) {
                self.showTotalSummary = true;
            }
        },
        showMoreLessContent() {
            var self = this;
            if (!self.showMoreLessFlag) {
                self.showMoreLessLabel = "Show Less"
                self.showMoreLessFlag = true;
                $("#vendor-invoice-line-items-tbl").removeClass("less-information");
            }else{
                self.showMoreLessLabel = "Show More"
                self.showMoreLessFlag = false;
                $("#vendor-invoice-line-items-tbl").addClass("less-information");
            }
        },

        onChargeSelect(event,index) {
            var self = this;
            if (self.chrows[index].charge_id != null && self.chrows[index].charge_id != "") {
                self.chrows[index].unit_price = self.chrows[index].charge_id.price;
                self.chrows[index].amount = self.chrows[index].charge_id.price;
            }else{
                self.chrows[index].unit_price = "";
                self.chrows[index].amount = "";
            }
            self.chrows[index].quantity = 1;
            self.calculateChargeAmount('',index);
        },
        onPOSelect($event) {
            var self = this;
            self.disablePOField = false;
            if (self.po != null) {
                if (self.po.type != undefined) {
                    if (self.po.type == "item") {
                        self.vendor_inv_type = "item";
                        self.vendor_invoice_type = {text:'Item' , value:'item'};
                    }else if (self.po.type == "equipment") {
                        self.vendor_inv_type = "equipment";
                        self.vendor_invoice_type = {text:'Equipment' , value:'equipment'};
                    }else if (self.po.type == "sublet_po") {
                        self.vendor_inv_type = "sublet_invoice";
                        self.vendor_invoice_type = {text:'Sublet Invoice' , value:'sublet_invoice'};
                    } else if (self.po.type == "equipment-osr") {

                    } else {
                        self.vendor_inv_type = "default";
                        self.vendor_invoice_type = {text:'Default' , value:'default'};
                    }
                } else{
                    // self.vendor_inv_type = "default";
                    // self.vendor_invoice_type = {text:'Default' , value:'default'};
                }
            }else{
                // self.vendor_inv_type = "default";
                // self.vendor_invoice_type = {text:'Default' , value:'default'};
            }
            self.rows = [];
            self.chrows = [];
            //Sublet Invoice
            if (self.vendor_inv_type == 'sublet_invoice') {
                self.rows.push({
                    bill_item_id:0,
                    quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                    quantity_error_msg: "",
                    unit_price: "",
                    unit_price_error_msg: "",
                    tax_percentage: 0,
                    tax_percentage_error_msg: "",
                    tax_amount_error_msg: "",
                    amount: 0,
                    total: 0,
                    description: "",
                    desc_error_msg: "",
                    part: null,
                    part_error_msg: "",
                    tax_id:"",
                    tax_amount:0,
                    gl_account_id:null,
                    gl_account_error_msg:"",
                    amount_error_msg:"",
                    enableTaxSelect:true,
                    labor:0,
                    vehicle_id:null,
                    labor_error_msg:"",
                    materials:0,
                    materials_error_msg:"",
                    wo_type:self.woType,
                    vehicle_error_msg:"",
                    wo_item_id:""
                });
                //charge
                self.chrows.push({
                    bill_item_id:0,
                    quantity: 0,
                    quantity_error_msg: "",
                    unit_price: 0,
                    unit_price_error_msg: "",
                    amount: 0,
                    charge_id: null,
                    description:"",
                    desc_error_msg:"",
                    disableChargeSelect:false,
                    amount_error_msg:"",
                    charge_type_error_msg:"",
                    vehicle_id:null
                })
            }else{
                self.rows.push({
                    bill_item_id:0,
                    quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                    quantity_error_msg: "",
                    unit_price: "",
                    unit_price_error_msg: "",
                    tax_percentage: 0,
                    tax_percentage_error_msg: "",
                    tax_amount_error_msg: "",
                    amount: 0,
                    total: 0,
                    description: "",
                    desc_error_msg: "",
                    part: null,
                    part_error_msg: "",
                    tax_id:"",
                    tax_amount:0,
                    gl_account_id:null,
                    gl_account_error_msg:"",
                    amount_error_msg:"",
                    enableTaxSelect:true,
                    labor:0,
                    vehicle_id:null,
                    labor_error_msg:"",
                    materials:0,
                    materials_error_msg:"",
                    wo_type:self.woType,
                    vehicle_error_msg:"",
                    wo_item_id:""
                });

                self.chrows.push({
                    bill_item_id: 0,
                    charge_id: null,
                    charge_type_error_msg: "",
                    quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                    quantity_error_msg: "",
                    unit_price: 0,
                    unit_price_error_msg: "",
                    amount: 0,
                    description:"",
                    desc_error_msg:"",
                    disableChargeSelect:false,
                    amount_error_msg:"",
                    vehicle_id:null
                });
            }
            self.sub_total = 0;
            self.total_tax = 0;
        },
        calculateSubletInvoice(event,index) {
            var self = this;
            var amount = 0;
            var taxAmount = 0

            for (var i = 0; i < self.rows.length; i++) {

                var itemTotal = 0;
                if (self.rows[i].labor != "" && self.rows[i].labor != "-" && self.rows[i].labor != ".") {
                    itemTotal += self.removeFormat(self.rows[i].labor);
                }
                if (self.rows[i].materials != "" && self.rows[i].materials != "-" && self.rows[i].materials != ".") {
                    itemTotal += self.removeFormat(self.rows[i].materials);
                }
                self.rows[i].amount = itemTotal;
                amount += self.rows[i].amount;
            }

            self.sub_total = amount.toFixed(2);
            // self.total_tax= parseFloat(taxAmount);
            self.pre_subtotal = self.sub_total;

            var charges = 0;
            var adminFee = 0;
            for (var k = 0; k < self.chrows.length; k++) {
                if (self.chrows[k].quantity != null && self.chrows[k].quantity != "" && self.chrows[k].quantity != "-") {
                    // if (self.chrows[k].charge_id != null) {
                    //     // if (self.chrows[k].charge_id.text != undefined && self.chrows[k].charge_id.text != null) {
                    //     //     if (self.chrows[k].charge_id.text.toLowerCase() == "admin fee" || self.chrows[k].charge_id.text.toLowerCase() == "nationalease admin fee") {
                    //     //         if (self.chrows[k].amount != null && self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                    //     //             adminFee += parseFloat(self.removeFormat(self.chrows[k].amount));
                    //     //         }
                    //     //     }else{
                    //     //         if (self.chrows[k].amount != null && self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                    //     //             charges += parseFloat(self.removeFormat(self.chrows[k].amount));
                    //     //         }
                    //     //     }
                    //     // }else{
                    //     //     if (self.chrows[k].amount != null && self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                    //     //         charges += parseFloat(self.removeFormat(self.chrows[k].amount));
                    //     //     }
                    //     // }
                    //     if (self.chrows[k].amount != null && self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                    //         charges += self.removeFormat(self.chrows[k].amount);
                    //     }
                    // }else{
                        if (self.chrows[k].amount != null && self.chrows[k].amount != "" && self.chrows[k].amount != "-") {
                            charges += self.removeFormat(self.chrows[k].amount);
                        }
                    //}
                }
            }
            self.admin_charge = adminFee.toFixed(2);
            var sub_total = amount + charges;
            self.sub_total = sub_total.toFixed(2);
        },
        onTypeSelect(event) {
            var self = this;
            if (self.vendor_invoice_type != null) {
                self.vendor_inv_type = self.vendor_invoice_type.value;
                self.rows = [];
                self.chrows = [];
                self.is_misc_po = 0;
                self.disablePOField = false;
                if (self.vendor_inv_type == 'default') {
                    if (self.po != null && self.po != "") {
                        self.is_misc_po = 1;
                        self.disablePOField = true;
                    }else{
                        self.po = "";
                    }
                }
                //if vendor_inv_type type is equipment then only mso charges will be loaded
                if (self.vendor_inv_type == 'equipment') {
                    self.loadFieldData(['mso_charges']);
                    self.chargesArr = [];
                    for(var i = 0;i < self.defaultChargesArr.length;i++){
                        if (self.defaultChargesArr[i].identifier == "DMVELECFIL" ||
                            self.defaultChargesArr[i].identifier == "MSOTITLEFEE" ||
                            self.defaultChargesArr[i].identifier == "licensing_fee"){
                            self.chargesArr.push(self.defaultChargesArr[i]);
                        }
                    }
                }else{
                    self.chargesArr = [];
                    for(var i = 0;i < self.defaultChargesArr.length;i++){
                        self.chargesArr.push(self.defaultChargesArr[i]);
                    }
                }
                //Sublet Invoice
                if (self.vendor_inv_type == 'sublet_invoice') {
                    self.rows.push({
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    });
                    //charge
                    self.chrows.push({
                        bill_item_id:0,
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        charge_id: null,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id:0,
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        charge_id: null,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id:0,
                        quantity: 0,
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        charge_id: null,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    })
                }else{
                    self.rows.push({
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },
                    {
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },
                    {
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    },{
                        bill_item_id:0,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: "",
                        unit_price_error_msg: "",
                        tax_percentage: 0,
                        tax_percentage_error_msg: "",
                        tax_amount_error_msg: "",
                        amount: 0,
                        total: 0,
                        description: "",
                        desc_error_msg: "",
                        part: null,
                        part_error_msg: "",
                        tax_id:"",
                        tax_amount:0,
                        gl_account_id:null,
                        gl_account_error_msg:"",
                        amount_error_msg:"",
                        enableTaxSelect:true,
                        labor:0,
                        vehicle_id:null,
                        labor_error_msg:"",
                        materials:0,
                        materials_error_msg:"",
                        wo_type:self.woType,
                        vehicle_error_msg:"",
                        wo_item_id:""
                    });

                    self.chrows.push({
                        bill_item_id: 0,
                        charge_id: null,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id: 0,
                        charge_id: null,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    },{
                        bill_item_id: 0,
                        charge_id: null,
                        quantity: (self.vendor_inv_type == "sublet_invoice")?1:"",
                        quantity_error_msg: "",
                        unit_price: 0,
                        unit_price_error_msg: "",
                        amount: 0,
                        description:"",
                        desc_error_msg:"",
                        disableChargeSelect:false,
                        amount_error_msg:"",
                        charge_type_error_msg:"",
                        vehicle_id:null
                    });
                }
                if (self.vendor_inv_type == 'default') {
                    self.chrows = [];
                }
                self.sub_total = 0;
                self.total_tax = 0;
            }
        },
        onSearchAssignee(search, loading) {
            var self = this;
            self.assignee_error = "";
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'bill_vendor', '');
            }
        },
        fetchVendorGL() {
            var self = this;
            if (self.vendor_id != null) {
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fetch-vendor-gl",
                    type: "POST",
                    data: {
                        'vendor_id': self.vendor_id.value
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                        //  console.log("---------");console.log(data.content[0].text); return;
                            self.vendorGLAccounts = data.content;
                        }else{
                            self.vendorGLAccounts = [];
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'fetch-vendor-gl');
                    },
                });
            }
        },
        onSearchAsset(search, loading) {
            var self = this;
            // use this in order to create new asset...
            if (search.length > 3) {
                loading(true);
                self.searchField(loading, search, 'vehicle');
            }
        },
        loadReceiptItem(poId,receiptId) {
            var self = this;
            console.log("loadReceiptItem :: poId :: "+ poId + " receiptId :: "+receiptId);
            self.$parent.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/po-charge-receipt-items",
                type: "POST",
                headers: this.ajxHeaders,
                data:{'po':poId,'poReceipt':receiptId},
                dataType: "json",
                success: function (data) {
                    self.$parent.loading = false;
                    // console.log(data);

                    if (data.status == "success") {

                        self.rows = [];
                        if (self.chrows.length  > 0) {

                        } else {
                          self.chrows = [];
                        }

                        var itemArr = [];
                        var vendor_po_type = "";
                        var receivedQtyArr = [];
                        if (data.received_qty != undefined && data.received_qty != null) {
                            var receivedQtyArr = data.received_qty;
                        }
                        var totalAmt = 0;
                        if (data.content.total != undefined && data.content.total != null) {
                            totalAmt = data.content.total;
                        }
                        var itemsFound = 0;
                        if (data.content.items != undefined && data.content.items != null) {

                            itemArr = data.content.items;
                            if (itemArr.length >= 1) {
                                itemsFound = 1;
                                for (var i = 0; i < itemArr.length; i++) {
                                    var poItemId = itemArr[i].po_item_id;
                                    //receipt item
                                    if (itemArr[i].line_type == "item") {
                                        var itemId = null;
                                        var vehicleId = null;
                                        var glAccountId = null;
                                        if (itemArr[i].item_id != null && itemArr[i].item_id != '') {
                                            itemId = {
                                                value: itemArr[i].item_id,
                                                text: itemArr[i].item
                                            };
                                        }
                                        if (itemArr[i].vehicle_id != null && itemArr[i].vehicle_id != '') {
                                            vehicleId = {
                                                value: itemArr[i].vehicle_id,
                                                text: itemArr[i].unit_no
                                            };
                                        }
                                        if (itemArr[i].gl_account_id != null && itemArr[i].gl_account_id != '') {
                                            glAccountId = {
                                                value: itemArr[i].gl_account_id,
                                                text: itemArr[i].gl_account
                                            };
                                        }
                                        self.rows.push({
                                            bill_item_id: 0,

                                            description: itemArr[i].po_item_desc,

                                            quantity: itemArr[i].quantity,
                                            quantity_error_msg: "",

                                            unit_price: self.amountFormat(itemArr[i].cost),
                                            unit_price_error_msg: "",
                                            tax_percentage: "",
                                            tax_percentage_error_msg: "",
                                            tax_id:"",

                                            amount: self.amountFormat(itemArr[i].total_cost),
                                            part: itemId,
                                            desc_error_msg:"",
                                            part_error_msg: "",
                                            labor:0,
                                            labor_error_msg:"",
                                            materials:0,
                                            materials_error_msg:"",
                                            gl_account_id:glAccountId,
                                            gl_account_error_msg:"",
                                            vehicle_id:vehicleId,
                                            wo_type:self.woType,
                                            vehicle_error_msg:"",
                                            wo_item_id:"",
                                            receipt_id:itemArr[i].receipt_id,
                                            po_item_id:poItemId,
                                            sale_tax:itemArr[i].sales_tax != undefined ? itemArr[i].sales_tax : 0,
                                        });
                                    }else{
                                        //po charge
                                        var chargeId = null;
                                        if (itemArr[i].charge_id != null) {
                                            chargeId = {
                                                value: itemArr[i].charge_id,
                                                text: itemArr[i].charge_name
                                            };
                                        }

                                        self.chrows.push({
                                            bill_item_id: 0,
                                            quantity: itemArr[i].quantity,
                                            quantity_error_msg: "",
                                            unit_price: self.amountFormat(itemArr[i].unit_price),
                                            unit_price_error_msg: "",
                                            amount: self.amountFormat(itemArr[i].total),
                                            charge_id: chargeId,
                                            description:"",
                                            desc_error_msg:"",
                                            disableChargeSelect:false,
                                            amount_error_msg:"",
                                            charge_type_error_msg:"",
                                            vehicle_id:null
                                        })
                                    }
                                }
                            }

                            if (!self.chrows || self.chrows.length == 0){
                                self.chrows.push({
                                    bill_item_id: 0,
                                    charge_id: null,
                                    charge_type_error_msg: "",
                                    quantity: 0,
                                    quantity_error_msg: "",
                                    unit_price: 0,
                                    unit_price_error_msg: "",
                                    amount: 0,
                                    description:"",
                                    desc_error_msg:"",
                                    disableChargeSelect:false,
                                    amount_error_msg:"",
                                    vehicle_id:null
                                });
                            }
                        }
                        if (itemsFound == 0){
                            self.rows.push({
                                bill_item_id:0,
                                quantity: "",
                                quantity_error_msg: "",
                                unit_price: "",
                                unit_price_error_msg: "",
                                tax_percentage: 0,
                                tax_percentage_error_msg: "",
                                tax_amount_error_msg: "",
                                amount: 0,
                                total: 0,
                                description: "",
                                desc_error_msg: "",
                                part: null,
                                part_error_msg: "",
                                tax_id:"",
                                tax_amount:0,
                                gl_account_id:null,
                                gl_account_error_msg:"",
                                amount_error_msg:"",
                                enableTaxSelect:true,
                                labor:0,
                                labor_error_msg:"",
                                materials:0,
                                materials_error_msg:"",
                                vehicle_id:null,
                                wo_type:self.woType,
                                vehicle_error_msg:"",
                                wo_item_id:""
                            });
                            self.chrows.push({
                                bill_item_id: 0,
                                charge_id: null,
                                charge_type_error_msg: "",
                                quantity: 0,
                                quantity_error_msg: "",
                                unit_price: 0,
                                unit_price_error_msg: "",
                                amount: 0,
                                description:"",
                                desc_error_msg:"",
                                disableChargeSelect:false,
                                amount_error_msg:"",
                                vehicle_id:null
                            });
                        }

                        self.showTotalSummary = true;


                        setTimeout(function(){
                            if(totalAmt != 0){
                                self.receipt_amount = self.amountFormat(totalAmt);
                                self.sub_total = totalAmt;
                            }
                        },1000);
                    }
                },
                error: function (jqXHR, exception) {
                    self.$parent.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-po-load-item')
                }
            });
        },
        afterComplete(file,response){
            var self = this;
        },
        storeDocument(file,response){
            var self = this;
            self.fileerror_msg = "";
            self.filesArr = [];
            self.docArr = [];
            self.validateDocs = [];
            var uploadResponse = response;

            //push doc path in doc array
            self.docArr.push(uploadResponse.content);
            self.filesArr.push(file);
            if (file.type != undefined) {
                var extension = file.type.split("/");
                self.validateDocs.push({
                    file_name:file.name,
                    size:file.size,
                    extension:extension[1]
                });
            }
        },
        removedSelectedFile(file, xhr, error) {
            var self = this;
            self.fileerror_msg = "";
            if (file.xhr != undefined) {
                var fileName = JSON.parse(file.xhr.response).content;

                var fileArr = fileName.split("/");

                self.removeFileFromServer(fileArr[1],"temp");

                for(var i = 0;i<self.docArr.length;i++){
                    if ( self.docArr[i].includes(fileName)) {
                        self.docArr.splice(i,1);
                        self.validateDocs.splice(i,1);
                        self.filesArr.splice(i,1);
                    }
                }
            }
        },
        removeFileFromServer(file,flag){
            var self = this;
            var billId = self.$route.params.id;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/remove-bill-file",
                type: "POST",
                data: {
                    doc_path : file,
                    bill_id: billId,
                    flag:flag
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-inv-doc-remove')
                }
            });
        },
        removeAllFiles() {
            var self = this;
            self.$refs.vendorInvDropzone.removeAllFiles();
        },
        //load files in drop zone
        loadFilesPreview:function() {
            var self = this;
            self.docArr = [];
            self.validateDocs = [];
            if ( self.dropZonePreviewFiles.length > 0 ) {
                for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
                    var url = self.dropZonePreviewFiles[i].url;
                    //get file path from url
                    self.docArr.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                    self.validateDocs.push({
                        file_name:self.dropZonePreviewFiles[i].display_name,
                        extension:self.dropZonePreviewFiles[i].ext
                    });
                }
            }
        },
        getFilePathFromUrl (value) {

            var path = "";
            var src = value.split('/');
            var file_name = src[src.length - 1];
            var orgPath = src[src.length - 2];
            path = orgPath + "/" + file_name;
            return path;

        },
        nationaleaseAdminFee() {
            var self = this;
            if (self.vendor_id != null) {
                if (self.vendor_id.code != undefined && self.vendor_id.code != null && self.vendor_id.code != "") {
                    var nationaleaseCharge = null;
                    if (self.vendorInvDocOptionalArr.includes(self.vendor_id.code)) {
                        for(var i = 0;i < self.chargesArr.length;i++){
                            if (self.chargesArr[i].identifier == "nationalease_admin_fee"){
                                nationaleaseCharge = self.chargesArr[i]
                            }
                        }
                    }
                    if (nationaleaseCharge != null) {
                        var flag = "push";
                        if (self.chrows.length > 0) {
                            if (self.chrows[0].charge_id != undefined && self.chrows[0].charge_id != null ){
                                if (!self.chrows[0].charge_id.value){
                                    flag = "empty";
                                }else{
                                    flag = "push";
                                }
                            }else{
                                flag = "empty";
                            }
                        }else{
                            flag = "empty";
                        }
                        if (flag == "empty") {
                            self.chrows = [];
                        }
                        self.chrows.push({
                            bill_item_id: 0,
                            charge_id: nationaleaseCharge,
                            charge_type_error_msg: "",
                            quantity: 1,
                            quantity_error_msg: "",
                            unit_price:(nationaleaseCharge.price != undefined && nationaleaseCharge.price != null)?nationaleaseCharge.price:0,
                            unit_price_error_msg: "",
                            amount:(nationaleaseCharge.price != undefined && nationaleaseCharge.price != null)?nationaleaseCharge.price:0,
                            description:"",
                            desc_error_msg:"",
                            disableChargeSelect:false,
                            amount_error_msg:"",
                            vehicle_id:null
                        });

                        var chIndex = self.chrows.length - 1;
                        self.calculateChargeAmount('',chIndex);
                    }
                }
            }
        }
    }
}
</script>
<style scoped>
.container { overflow: hidden; }
</style>



// WEBPACK FOOTER //
// src/components/accounting/VendorInvoiceForm.vue